(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beni-count-down"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customElements.get('beni-count-down')) return;

    // 所有实例共用一个对齐到整秒边界的定时器，避免每个实例各自 setInterval 造成的抖动与开销。
    const instances = new Set();
    let timerId = null;

    const scheduleTick = () => {
      if (timerId !== null || instances.size === 0) return;

      timerId = window.setTimeout(() => {
        timerId = null;
        instances.forEach((instance) => instance.refresh());
        scheduleTick();
      }, 1000 - (Date.now() % 1000));
    };

    const stopTicker = () => {
      if (timerId === null) return;
      window.clearTimeout(timerId);
      timerId = null;
    };

    const register = (instance) => {
      instances.add(instance);
      scheduleTick();
    };

    const unregister = (instance) => {
      instances.delete(instance);
      if (instances.size === 0) stopTicker();
    };

    const pad = (value) => String(value).padStart(2, '0');

    // 时间来源只认绝对时刻，与 assets/section-beni-announcement-bar.js 同一条规则：
    // 与服务端的店铺时区差出「店铺偏移 − 访客偏移」，同一条公告在不同地区的归零时刻就不一致。
    // 因此只接受自带时区的串（结尾 Z 或 ±HH:MM / ±HHMM），其余返回 0 —— 宁可不显示，也不显示错的。
    // 要求偏移量前面确实是 HH:MM，排除 '12-31-2026' 这类以 -YYYY 结尾、形似偏移量的日期串。
    const ABSOLUTE_TIME = /\d{2}:\d{2}(?::\d{2})?(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})$/;

    const parseAbsolute = (input) => {
      const raw = (input || '').trim();
      if (!ABSOLUTE_TIME.test(raw)) return 0;

      // '2026-12-31 23:59:59-08:00' 这种空格分隔的写法不是合规 ISO，部分浏览器解析不了，
      // 补成 T 分隔再交给 Date（已经带 T 的串不含空格，replace 是空操作）。
      const parsed = new Date(raw.replace(' ', 'T')).getTime();

      return Number.isNaN(parsed) ? 0 : parsed;
    };

    class BeniCountDown extends HTMLElement {
      constructor() {
        super();
        this.hasExpired = false;
        this.elements = null;
      }

      connectedCallback() {
        // 服务端给出的 epoch 是按店铺时区解析的，优先采用；为 0 说明 Liquid 没解析出格式，
        // 此时只认自带时区的原始串，仍解析不出就整块隐藏（见下面的 hidden）。
        const serverEpoch = Number(this.dataset.end || 0);
        this.endTime = serverEpoch > 0 ? serverEpoch * 1000 : parseAbsolute(this.dataset.endDate);

        if (!this.endTime) {
          this.hidden = true;
          return;
        }

        this.refresh();

        if (!this.hasExpired) register(this);
      }

      disconnectedCallback() {
        unregister(this);
      }

      get parts() {
        if (this.elements) return this.elements;

        const unit = (name) => {
          const host = this.querySelector(`[data-unit="${name}"]`);
          return {
            host,
            value: host ? host.querySelector('[data-countdown-value]') : null
          };
        };

        this.elements = {
          days: unit('days'),
          hours: unit('hours'),
          minutes: unit('minutes'),
          seconds: unit('seconds')
        };

        return this.elements;
      }

      // 以客户端绝对时间戳与结束时间戳比较：两者都是 epoch，不涉及时区解析，
      // 同时能自我修正 Shopify 整页缓存导致的服务端 now 偏差。
      refresh() {
        const remaining = this.endTime - Date.now();

        if (remaining <= 0) {
          this.expire();
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const parts = this.parts;

        this.write(parts.days.value, days);
        this.write(parts.hours.value, Math.floor((totalSeconds % 86400) / 3600));
        this.write(parts.minutes.value, Math.floor((totalSeconds % 3600) / 60));
        this.write(parts.seconds.value, totalSeconds % 60);

        // 跨过 24 小时边界时摘掉「天」，而不是靠 CSS 藏起来。
        // 冒号在「天」这一列内部，隐藏整列即一并消失，无需单独处理。
        if (parts.days.host) parts.days.host.hidden = days === 0;

        // 数字已经是真值，撤掉服务端的占位态。
        this.classList.remove('is-pending');
      }

      write(element, value) {
        if (!element) return;

        const text = pad(value);
        if (element.textContent !== text) element.textContent = text;
      }

      expire() {
        if (this.hasExpired) return;

        this.hasExpired = true;
        unregister(this);

        if (this.dataset.endAction === 'hide_block' && this.dataset.blockId) {
          this.dispatchEvent(
            new CustomEvent('beni:announcement-block-expired', {
              bubbles: true,
              detail: { blockId: this.dataset.blockId }
            })
          );
          return;
        }

        this.hidden = true;
      }
    }

    window.customElements.define('beni-count-down', BeniCountDown);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-media-crossfade"] && !Shopify.designMode) return;
  try {
    (() => {
    const transitions = new WeakMap();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const visibleMedia = (container) =>
      [...container.querySelectorAll('img, video')].find((media) => media.getClientRects().length > 0);

    const clear = (container) => {
      const transition = transitions.get(container);
      if (!transition) return;
      transitions.delete(container);
      transition.controller.abort();
      transition.animation?.cancel();
      transition.canvas.remove();
      transition.restoreHeight();
    };

    const snapshot = (container) => {
      const media = visibleMedia(container);
      const previous = transitions.get(container)?.canvas;
      const bounds = container.getBoundingClientRect();
      if ((!media && !previous) || !bounds.width || !bounds.height) return null;
      const canvas = document.createElement('canvas');
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.ceil(bounds.width * ratio);
      canvas.height = Math.ceil(bounds.height * ratio);
      canvas.className = 'wt-media-crossfade';
      canvas.setAttribute('aria-hidden', 'true');
      const context = canvas.getContext('2d');
      if (!context) return null;
      let painted = false;
      if (media) {
        const width = media.videoWidth || media.naturalWidth;
        const height = media.videoHeight || media.naturalHeight;
        if (width && height) {
          const fit = window.getComputedStyle(media).objectFit;
          const scale = (fit === 'contain' ? Math.min : Math.max)(canvas.width / width, canvas.height / height);
          const drawWidth = fit === 'fill' ? canvas.width : width * scale;
          const drawHeight = fit === 'fill' ? canvas.height : height * scale;
          try {
            context.drawImage(media, (canvas.width - drawWidth) / 2, (canvas.height - drawHeight) / 2, drawWidth, drawHeight);
            painted = true;
          } catch {
            // A video without a decoded frame can still have an earlier transition covering it.
          }
        }
      }
      if (previous) {
        context.globalAlpha = Number(window.getComputedStyle(previous).opacity);
        context.drawImage(previous, 0, 0, canvas.width, canvas.height);
        painted = true;
      }
      return painted ? canvas : null;
    };

    const waitForMedia = async (container, signal) => {
      const media = visibleMedia(container);
      if (!media || signal.aborted) return;
      const video = media.tagName === 'VIDEO';
      if (!video) media.loading = 'eager';
      if (!(video ? media.readyState >= 2 && !media.seeking : media.complete)) {
        await new Promise((resolve) => {
          const event = video ? (media.seeking ? 'seeked' : 'loadeddata') : 'load';
          const finish = () => {
            window.clearTimeout(timeout);
            media.removeEventListener(event, finish);
            media.removeEventListener('error', finish);
            signal.removeEventListener('abort', finish);
            resolve();
          };
          const timeout = window.setTimeout(finish, 8000);
          media.addEventListener(event, finish, { once: true });
          media.addEventListener('error', finish, { once: true });
          signal.addEventListener('abort', finish, { once: true });
        });
      }
      if (!video && media.naturalWidth && !signal.aborted) {
        try {
          await media.decode();
        } catch {
          // Failed images retain the browser's normal fallback.
        }
      }
      if (video && !media.paused && media.readyState >= 2 && !signal.aborted) {
        // Match yg-video: hand over only after a decoded frame reaches the compositor.
        if (typeof media.requestVideoFrameCallback === 'function') {
          await new Promise((resolve) => {
            const finish = () => {
              window.clearTimeout(timeout);
              media.cancelVideoFrameCallback(frame);
              signal.removeEventListener('abort', finish);
              resolve();
            };
            const timeout = window.setTimeout(finish, 5000);
            const frame = media.requestVideoFrameCallback(finish);
            signal.addEventListener('abort', finish, { once: true });
          });
        } else {
          await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        }
      }
    };

    /** Capture before changing panels; call the returned function after the new panel is visible. */
    window.wtMediaCrossfade = (pairs) => {
      const snapshots = [];
      for (const [previous, next] of pairs) {
        if (!previous || !next || previous === next) continue;
        const height = previous.getBoundingClientRect().height;
        const canvas = reducedMotion.matches ? null : snapshot(previous);
        clear(previous);
        clear(next);
        if (canvas) snapshots.push({ canvas, next, height });
      }
      return () => {
        for (const { canvas, next, height } of snapshots) {
          const minHeight = next.style.minHeight;
          const reserveHeight = next.getBoundingClientRect().height < 1;
          if (reserveHeight) next.style.minHeight = `${height}px`;
          const transition = {
            canvas,
            controller: new AbortController(),
            animation: null,
            restoreHeight: () => {
              if (reserveHeight) next.style.minHeight = minHeight;
            },
          };
          transitions.set(next, transition);
          next.append(canvas);
          void (async () => {
            await waitForMedia(next, transition.controller.signal);
            if (transitions.get(next) !== transition) return;
            transition.animation = canvas.animate([{ opacity: 1 }, { opacity: 0 }], {
              duration: reducedMotion.matches ? 0 : 550,
              easing: 'ease',
              fill: 'forwards',
            });
            try {
              await transition.animation.finished;
            } catch {
              return;
            }
            if (transitions.get(next) === transition) clear(next);
          })();
        }
      };
    };

    document.addEventListener('shopify:section:unload', (event) => {
      for (const canvas of event.target.querySelectorAll('.wt-media-crossfade')) clear(canvas.parentElement);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-media-playback"] && !Shopify.designMode) return;
  try {
    (() => {
    window.wtMediaPlayback = (viewport, { isActive = () => true } = {}) => {
      const videos = [...viewport.querySelectorAll('video')];
      const mobileQuery = window.matchMedia('(max-width: 768px)');
      const inView = new Set();
      let destroyed = false;

      for (const video of videos) {
        video.autoplay = false;
        video.preload = 'none';
      }

      const matchesDevice = (video) => {
        const wrap = video.closest('.wt-media--has-mobile-video');
        if (!wrap) return true;
        return mobileQuery.matches
          ? video.classList.contains('wt-media__video--mobile')
          : video.classList.contains('wt-media__video--desktop');
      };

      const sync = (restart = null) => {
        if (destroyed) return;
        window.wtMediaResponsiveVideo?.apply(viewport);
        for (const video of videos) {
          if (!matchesDevice(video)) {
            video.pause();
            continue;
          }
          if (restart?.contains(video)) {
            video.pause();
            // Reset without reloading the source or discarding its decoded frames.
            try {
              video.currentTime = 0;
            } catch {
              // Unloaded media already starts at zero when its metadata becomes available.
            }
          }
          if (inView.has(video) && !document.hidden && isActive(video) && video.getClientRects().length > 0) {
            if (video.paused) video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      };

      window.wtMediaResponsiveVideo?.apply(viewport);

      const stopInView = Motion.inView(
        videos,
        (video) => {
          inView.add(video);
          sync();
          return () => {
            inView.delete(video);
            sync();
          };
        },
        { amount: 0.15 }
      );
      // Event listeners pass an event rather than the optional panel to restart.
      const onVisibilityChange = () => sync();
      mobileQuery.addEventListener('change', onVisibilityChange);
      document.addEventListener('visibilitychange', onVisibilityChange);
      sync();

      return {
        sync,
        destroy() {
          destroyed = true;
          stopInView();
          mobileQuery.removeEventListener('change', onVisibilityChange);
          document.removeEventListener('visibilitychange', onVisibilityChange);
          for (const video of videos) video.pause();
        },
      };
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wt-media"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.wtMediaResponsiveVideo) return;

    const mobileQuery = window.matchMedia('(max-width: 768px)');

    const stash = (video) => {
      if (!video.dataset.wtMediaMarkup) {
        video.dataset.wtMediaMarkup = video.innerHTML;
        if (video.hasAttribute('src')) video.dataset.wtMediaSrc = video.getAttribute('src');
        if (video.hasAttribute('poster')) video.dataset.wtMediaPoster = video.getAttribute('poster');
      }
    };

    const unload = (video) => {
      if (!video || video.dataset.wtMediaUnloaded === 'true') return;
      stash(video);
      video.pause();
      video.removeAttribute('src');
      video.removeAttribute('poster');
      video.querySelectorAll('source').forEach((source) => source.remove());
      video.load();
      video.dataset.wtMediaUnloaded = 'true';
    };

    const load = (video) => {
      if (!video || video.dataset.wtMediaUnloaded !== 'true') return;
      if (video.dataset.wtMediaMarkup) video.innerHTML = video.dataset.wtMediaMarkup;
      if (video.dataset.wtMediaSrc) video.setAttribute('src', video.dataset.wtMediaSrc);
      else video.removeAttribute('src');
      if (video.dataset.wtMediaPoster) video.setAttribute('poster', video.dataset.wtMediaPoster);
      else video.removeAttribute('poster');
      delete video.dataset.wtMediaUnloaded;
      video.load();
    };

    const apply = (root = document) => {
      for (const wrap of root.querySelectorAll('.wt-media--has-mobile-video')) {
        const desktop = wrap.querySelector('.wt-media__video--desktop');
        const mobile = wrap.querySelector('.wt-media__video--mobile');
        if (mobileQuery.matches) {
          unload(desktop);
          load(mobile);
        } else {
          unload(mobile);
          load(desktop);
        }
      }
    };

    window.wtMediaResponsiveVideo = { apply };
    document.addEventListener('DOMContentLoaded', () => apply(), { once: true });
    document.addEventListener('shopify:section:load', (event) => apply(event.target));
    mobileQuery.addEventListener('change', () => apply());
    if (document.readyState !== 'loading') apply();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      static sectionsMutationObserver = null;
      static activePositionFrame = null;
      static isPositionTrackingInitialized = false;
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.itemClick);
        YGAnchorItem.#ensurePositionTracking();
        YGAnchorItem.#scheduleActiveItemUpdate();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
      }

      static #ensurePositionTracking() {
        if (YGAnchorItem.isPositionTrackingInitialized) return;
        YGAnchorItem.isPositionTrackingInitialized = true;

        window.addEventListener('scroll', YGAnchorItem.#scheduleActiveItemUpdate, { passive: true });
        window.addEventListener('resize', YGAnchorItem.#scheduleActiveItemUpdate);

        const mainContent = document.querySelector('#MainContent');
        if (mainContent && typeof MutationObserver !== 'undefined') {
          YGAnchorItem.sectionsMutationObserver = new MutationObserver(YGAnchorItem.#scheduleActiveItemUpdate);
          YGAnchorItem.sectionsMutationObserver.observe(mainContent, { childList: true });
        }
      }

      static #scheduleActiveItemUpdate() {
        if (YGAnchorItem.activePositionFrame !== null) return;

        YGAnchorItem.activePositionFrame = window.requestAnimationFrame(() => {
          YGAnchorItem.activePositionFrame = null;
          YGAnchorItem.#updateActiveItems();
        });
      }

      static #updateActiveItems() {
        const sections = Array.from(document.querySelectorAll('#MainContent > .shopify-section'));
        const anchorGroups = new Map();

        document.querySelectorAll('yg-anchor-item[data-section-number]').forEach((item) => {
          const id = item.getAttribute('data-id');
          const groupKey = id ? `id:${id}` : item.closest('yg-anchor-tab') || item.parentElement;
          if (!groupKey) return;
          if (!anchorGroups.has(groupKey)) anchorGroups.set(groupKey, []);
          anchorGroups.get(groupKey).push(item);
        });

        anchorGroups.forEach((items) => {
          const anchorContainer = items[0]?.closest('yg-anchor-tab')?.querySelector('.yg-anchor-container');
          const rootStyles = window.getComputedStyle(document.documentElement);
          const headerHeight = Number.parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
          const headerTop = Math.max(0, document.querySelector('.section-header')?.getBoundingClientRect().top || 0);
          const anchorHeight = anchorContainer?.getBoundingClientRect().height || 0;
          const activePosition = headerHeight + headerTop + anchorHeight;
          const logicalItems = [];
          const sectionNumbers = new Set();

          items.forEach((item) => {
            const sectionNumber = Number(item.getAttribute('data-section-number'));
            if (!Number.isFinite(sectionNumber) || sectionNumbers.has(sectionNumber)) return;
            sectionNumbers.add(sectionNumber);
            logicalItems.push({ item, sectionNumber, section: sections[sectionNumber - 1] });
          });

          let targetItem = null;
          let nearestDistance = Number.POSITIVE_INFINITY;
          let nearestSectionTop = Number.NEGATIVE_INFINITY;
          const positionTolerance = 1;
          logicalItems.forEach((entry) => {
            if (!entry.section) return;
            const sectionRect = entry.section.getBoundingClientRect();
            const isCrossingActivePosition =
              sectionRect.top <= activePosition + positionTolerance &&
              sectionRect.bottom >= activePosition - positionTolerance;
            const isBelowActivePosition = sectionRect.top > activePosition + positionTolerance;
            if (!isCrossingActivePosition && !isBelowActivePosition) return;

            const distance = isCrossingActivePosition ? 0 : sectionRect.top - activePosition;
            const isNearer = distance < nearestDistance;
            const isLaterAtSameDistance = distance === nearestDistance && sectionRect.top > nearestSectionTop;
            if (isNearer || isLaterAtSameDistance) {
              nearestDistance = distance;
              nearestSectionTop = sectionRect.top;
              targetItem = entry.item;
            }
          });

          targetItem ||= logicalItems.at(-1)?.item || null;
          if (!targetItem || targetItem.classList.contains('active')) return;
          targetItem.setActiveFromObserver();
        });
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) this.labelClick();
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick() {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const targetCenter = targetRect.left - containerRect.left + parent.scrollLeft + targetRect.width / 2;
          const maxScrollLeft = parent.scrollWidth - parent.clientWidth;
          const scrollLeft = Math.min(Math.max(targetCenter - parent.clientWidth / 2, 0), maxScrollLeft);

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        if (this.closest('yg-anchor-tab')) return;

        const sectionNumber = this.getAttribute('data-section-number');
        const sections = document.querySelectorAll('#MainContent > .shopify-section');
        YGAnchorItem.isScroll = true;
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-buy-buttons')) {
    customElements.define(
      'yg-buy-buttons',
      class YGBuyButtons extends HTMLElement {
        connectedCallback() {
          if (this.isInitialized) return;
          this.isInitialized = true;
          this.productInfo = this.closest('product-info');
          this.form = document.getElementById(this.dataset.productFormId);
          this.productForm = this.form?.closest('product-form');
          this.installmentElement = this.querySelector('[data-yg-buy-buttons-installment]');
          this.itemsContainer = this.querySelector('[data-yg-buy-buttons-items]');
          this.totalElement = this.querySelector('[data-yg-buy-buttons-total]');
          this.subscriptionToast = this.subscriptionToast || this.querySelector('[data-yg-klaviyo-subscription-toast]');
          this.variantPicker = this.productInfo?.querySelector('yg-variant-kit-picker');
          this.addons = this.productInfo?.querySelector('yg-product-addons');
          this.variants = this.parseVariants();
          this.handleClick = this.handleClick.bind(this);
          this.handleStateChange = this.handleStateChange.bind(this);
          this.handleFormChange = this.handleFormChange.bind(this);
          this.handleAddToCartSuccess = this.handleAddToCartSuccess.bind(this);
          this.handleFavoriteStateChange = this.handleFavoriteStateChange.bind(this);
          this.handleKlaviyoFormEvent = this.handleKlaviyoFormEvent.bind(this);
          this.addEventListener('click', this.handleClick);
          window.addEventListener('yg:klaviyo-favorite-change', this.handleFavoriteStateChange);
          window.addEventListener('klaviyoForms', this.handleKlaviyoFormEvent);
          this.productInfo?.addEventListener('yg:variant-change', this.handleStateChange);
          this.productInfo?.addEventListener('yg:addons-change', this.handleStateChange);
          this.form?.addEventListener('change', this.handleFormChange);
          this.productForm?.addEventListener('product-form:success', this.handleAddToCartSuccess);
          this.refresh();
          this.initializeInstallmentMessaging();
          this.updateFavoriteState();
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          window.removeEventListener('yg:klaviyo-favorite-change', this.handleFavoriteStateChange);
          window.removeEventListener('klaviyoForms', this.handleKlaviyoFormEvent);
          this.productInfo?.removeEventListener('yg:variant-change', this.handleStateChange);
          this.productInfo?.removeEventListener('yg:addons-change', this.handleStateChange);
          this.form?.removeEventListener('change', this.handleFormChange);
          this.productForm?.removeEventListener('product-form:success', this.handleAddToCartSuccess);
          window.clearTimeout(this.subscriptionToastHideTimer);
          window.clearTimeout(this.subscriptionToastRemoveTimer);
          this.stopKlaviyoPopupWatch();
          this.setFavoriteLoading(false);
          this.subscriptionToast?.remove();
          this.isInitialized = false;
        }

        parseVariants() {
          try {
            return JSON.parse(this.querySelector('[data-yg-buy-buttons-variants]')?.textContent || '[]');
          } catch (error) {
            return [];
          }
        }

        handleClick(event) {
          if (event.target.closest('[data-yg-buy-buttons-reset]')) {
            this.reset();
            return;
          }
          const favoriteButton = event.target.closest('[data-yg-buy-buttons-favorite]');
          if (favoriteButton) {
            if (window.ygKlaviyoFavorite?.isFavorited()) {
              this.updateFavoriteState();
              return;
            }

            const formId = favoriteButton.dataset.klaviyoFormId;
            if (!formId || favoriteButton.classList.contains('is-loading')) return;
            this.setFavoriteLoading(true);
            try {
              this.prepareKlaviyoCheckboxDefaults(formId);
              window._klOnsite = window._klOnsite || [];
              window._klOnsite.push(['openForm', formId]);
            } catch (error) {
              this.stopKlaviyoPopupWatch();
              this.setFavoriteLoading(false);
              console.error('Unable to open the Klaviyo favorites form.', error);
            }
          }
        }

        setFavoriteLoading(isLoading) {
          const favoriteButton = this.querySelector('[data-yg-buy-buttons-favorite]');
          if (!favoriteButton) return;

          favoriteButton.classList.toggle('is-loading', isLoading);
          if (isLoading) {
            favoriteButton.setAttribute('aria-busy', 'true');
          } else {
            favoriteButton.removeAttribute('aria-busy');
          }
          this.updateFavoriteState();
        }

        stopKlaviyoPopupWatch() {
          window.clearTimeout(this.klaviyoCheckboxTimer);
          this.klaviyoCheckboxTimer = undefined;
          this.klaviyoCheckboxObserver?.disconnect();
          this.klaviyoCheckboxObserver = undefined;
        }

        findVisibleKlaviyoPopup(formId) {
          const formTestId = formId ? `klaviyo-form-${formId}` : '';

          return Array.from(document.querySelectorAll('[data-testid=POPUP]')).find((popup) => {
            const popupStyles = window.getComputedStyle(popup);
            const isVisible = popupStyles.display !== 'none'
              && popupStyles.visibility !== 'hidden'
              && popup.getClientRects().length > 0;
            const matchesForm = !formTestId
              || popup.dataset.testid === formTestId
              || Array.from(popup.querySelectorAll('[data-testid]')).some(
                (element) => element.dataset.testid === formTestId,
              );

            return isVisible && matchesForm;
          });
        }

        prepareKlaviyoCheckboxDefaults(formId) {
          this.stopKlaviyoPopupWatch();

          const applyDefault = () => {
            const popup = this.findVisibleKlaviyoPopup(formId);
            if (!popup) return false;
            this.setFavoriteLoading(false);

            const checkboxes = Array.from(popup.querySelectorAll('input[type=checkbox]')).filter(
              (input) => !input.disabled,
            );
            if (!checkboxes.length) return false;

            const checkedSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked')?.set;
            checkboxes.forEach((checkbox) => {
              if (checkbox.checked) return;

              checkbox.click();
              if (checkbox.checked) return;

              if (checkedSetter) {
                checkedSetter.call(checkbox, true);
              } else {
                checkbox.checked = true;
              }
              checkbox.setAttribute('checked', '');
              checkbox.dispatchEvent(new Event('input', { bubbles: true }));
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            });

            this.stopKlaviyoPopupWatch();
            return true;
          };

          if (applyDefault()) return;

          this.klaviyoCheckboxObserver = new MutationObserver(applyDefault);
          this.klaviyoCheckboxObserver.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['aria-hidden', 'class', 'style'],
          });
          this.klaviyoCheckboxTimer = window.setTimeout(() => {
            this.stopKlaviyoPopupWatch();
            this.setFavoriteLoading(false);
          }, 10000);
        }

        updateFavoriteState() {
          const favoriteButton = this.querySelector('[data-yg-buy-buttons-favorite]');
          if (!favoriteButton) return;

          const isFavorited = Boolean(window.ygKlaviyoFavorite?.isFavorited());
          const defaultPrefix = favoriteButton.querySelector('[data-yg-favorite-default-prefix]');
          const defaultAction = favoriteButton.querySelector('[data-yg-favorite-default-action]');
          const successCopy = favoriteButton.querySelector('[data-yg-favorite-success-copy]');
          const loader = favoriteButton.querySelector('[data-yg-favorite-loader]');
          const isLoading = favoriteButton.classList.contains('is-loading');

          favoriteButton.classList.toggle('is-favorited', isFavorited);
          favoriteButton.setAttribute('aria-pressed', String(isFavorited));
          favoriteButton.setAttribute(
            'aria-label',
            isFavorited
              ? favoriteButton.dataset.favoriteSuccessText
              : [defaultPrefix?.textContent, defaultAction?.textContent].filter(Boolean).join(' ')
          );

          if (defaultPrefix) defaultPrefix.hidden = isFavorited || isLoading;
          if (defaultAction) defaultAction.hidden = isFavorited || isLoading;
          if (successCopy) successCopy.hidden = !isFavorited || isLoading;
          if (loader) loader.hidden = !isLoading;

          if (isFavorited) {
            favoriteButton.removeAttribute('aria-haspopup');
          } else {
            favoriteButton.setAttribute('aria-haspopup', 'dialog');
          }
        }

        handleFavoriteStateChange() {
          this.updateFavoriteState();
        }

        handleKlaviyoFormEvent(event) {
          const detail = event.detail || {};
          const favoriteButton = this.querySelector('[data-yg-buy-buttons-favorite]');
          const eventFormId = detail.formId || detail.formID;
          if (eventFormId !== favoriteButton?.dataset.klaviyoFormId) return;
          if (detail.type === 'open') {
            this.setFavoriteLoading(false);
            this.prepareKlaviyoCheckboxDefaults(eventFormId);
            return;
          }
          if (detail.type !== 'submit') return;
          this.showSubscriptionToast();
        }

        showSubscriptionToast() {
          const toast = this.subscriptionToast;
          if (!toast) return;

          window.clearTimeout(this.subscriptionToastHideTimer);
          window.clearTimeout(this.subscriptionToastRemoveTimer);
          if (toast.parentElement !== document.body) document.body.append(toast);
          toast.hidden = false;
          window.requestAnimationFrame(() => toast.classList.add('is-visible'));

          this.subscriptionToastHideTimer = window.setTimeout(() => {
            toast.classList.remove('is-visible');
            this.subscriptionToastRemoveTimer = window.setTimeout(() => {
              toast.hidden = true;
            }, 250);
          }, 4000);
        }

        handleStateChange() {
          this.refresh();
        }

        handleFormChange(event) {
          if (event.target?.name === 'id') this.refresh();
        }

        handleAddToCartSuccess() {
          this.reset();
        }

        reset() {
          this.addons?.resetQuantities?.();
          const firstCard = this.variantPicker?.querySelector('[data-variant-card]');
          if (firstCard) {
            this.variantPicker.selectVariantById(firstCard.dataset.variantId);
            return;
          }

          const firstVariant = this.variants.find((variant) => variant.available) || this.variants[0];
          const variantInput = this.form?.querySelector('[name="id"]');
          if (!firstVariant || !variantInput) {
            this.refresh();
            return;
          }
          variantInput.disabled = false;
          variantInput.value = String(firstVariant.id);
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        getCurrentVariant() {
          const activeCard = this.variantPicker?.querySelector('[data-variant-card].is-active');
          if (activeCard) {
            return {
              id: Number.parseInt(activeCard.dataset.variantId, 10),
              title: activeCard.dataset.variantTitle || '',
              price: Number.parseInt(activeCard.dataset.variantPrice, 10) || 0,
              available: activeCard.dataset.variantAvailable === 'true',
            };
          }

          const variantId = Number.parseInt(this.form?.querySelector('[name="id"]')?.value, 10);
          return this.variants.find((variant) => Number(variant.id) === variantId) || this.variants.find((variant) => variant.available) || this.variants[0];
        }

        getSelectedAddons() {
          return Array.from(this.productInfo?.querySelectorAll('[data-product-addon-item]') || [])
            .map((item) => ({
              title: item.dataset.productTitle || '',
              price: Number.parseInt(item.dataset.price, 10) || 0,
              quantity: Number.parseInt(item.dataset.quantity, 10) || 0,
            }))
            .filter((item) => item.quantity > 0);
        }

        refresh() {
          const variant = this.getCurrentVariant();
          if (!variant || !this.itemsContainer || !this.totalElement) return;
          const addons = this.getSelectedAddons();
          const fragment = document.createDocumentFragment();
          fragment.append(this.createRow(variant.title, variant.price, 1));
          addons.forEach((addon) => fragment.append(this.createRow(addon.title, addon.price * addon.quantity, addon.quantity)));
          this.itemsContainer.replaceChildren(fragment);
          const total = addons.reduce((sum, addon) => sum + addon.price * addon.quantity, Number(variant.price) || 0);
          this.totalElement.textContent = this.formatMoney(total);
          this.updateInstallmentAmount(total);
        }

        initializeInstallmentMessaging() {
          if (!this.installmentElement) return;
          if (this.dataset.installmentProvider === 'affirm') {
            this.loadAffirm().then(() => this.refreshInstallmentMessaging());
          } else if (this.dataset.installmentProvider === 'klarna') {
            this.loadKlarna().then(() => this.refreshInstallmentMessaging());
          }
        }

        loadAffirm() {
          if (window.affirm?.ui?.refresh) return Promise.resolve();
          if (window.ygAffirmReadyPromise) return window.ygAffirmReadyPromise;

          if (window.affirm?.ui?.ready) {
            window.ygAffirmReadyPromise = new Promise((resolve) => window.affirm.ui.ready(resolve));
            return window.ygAffirmReadyPromise;
          }

          const script =
            this.dataset.affirmEnvironment === 'sandbox'
              ? 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'
              : 'https://cdn1.affirm.com/js/v2/affirm.js';
          window._affirm_config = {
            public_api_key: this.dataset.affirmPublicApiKey,
            script,
            locale: this.dataset.affirmLocale,
            country_code: this.dataset.affirmCountryCode,
          };

          ((m, g, n, d, a, e, h, c) => {
            const b = m[n] || {};
            const k = document.createElement(e);
            const p = document.getElementsByTagName(e)[0];
            const l = (target, method, queue) =>
              function queueAffirmCall() {
                target[method]._.push([queue, arguments]);
              };
            b[d] = l(b, d, 'set');
            const f = b[d];
            b[a] = {};
            b[a]._ = [];
            f._ = [];
            b._ = [];
            b[a][h] = l(b, a, h);
            b[c] = function queueAffirmReady() {
              b._.push([h, arguments]);
            };
            let index = 0;
            const checkoutMethods = 'set add save post open empty reset on off trigger ready setProduct'.split(' ');
            for (; index < checkoutMethods.length; index += 1) f[checkoutMethods[index]] = l(b, d, checkoutMethods[index]);
            index = 0;
            const checkoutGetters = ['get', 'token', 'url', 'items'];
            for (; index < checkoutGetters.length; index += 1) f[checkoutGetters[index]] = function affirmGetter() {};
            k.async = true;
            k.src = g[e];
            p.parentNode.insertBefore(k, p);
            delete g[e];
            f(g);
            m[n] = b;
          })(window, window._affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready', 'jsReady');

          window.ygAffirmReadyPromise = new Promise((resolve) => window.affirm.ui.ready(resolve));
          return window.ygAffirmReadyPromise;
        }

        loadKlarna() {
          if (window.Klarna?.OnsiteMessaging) return Promise.resolve();
          if (window.ygKlarnaReadyPromise) return window.ygKlarnaReadyPromise;

          window.ygKlarnaReadyPromise = new Promise((resolve) => {
            let script = document.querySelector('script[src="https://js.klarna.com/web-sdk/v1/klarna.js"]');
            if (!script) {
              script = document.createElement('script');
              script.async = true;
              script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
              script.dataset.clientId = this.dataset.klarnaClientId;
              script.dataset.environment = this.dataset.klarnaEnvironment || 'production';
              document.head.append(script);
            }

            let attempts = 0;
            const waitForKlarna = () => {
              if (window.Klarna?.OnsiteMessaging || attempts >= 100) {
                resolve();
                return;
              }
              attempts += 1;
              window.setTimeout(waitForKlarna, 100);
            };
            waitForKlarna();
          });
          return window.ygKlarnaReadyPromise;
        }

        updateInstallmentAmount(total) {
          if (!this.installmentElement) return;
          const amount = String(Math.max(0, Math.round(Number(total) || 0)));
          if (this.dataset.installmentProvider === 'affirm') {
            this.installmentElement.dataset.amount = amount;
          } else if (this.dataset.installmentProvider === 'klarna') {
            this.installmentElement.dataset.purchaseAmount = amount;
          }
          this.refreshInstallmentMessaging();
        }

        refreshInstallmentMessaging() {
          if (this.dataset.installmentProvider === 'affirm') {
            window.affirm?.ui?.refresh?.();
          } else if (this.dataset.installmentProvider === 'klarna') {
            window.Klarna?.OnsiteMessaging?.refresh?.();
          }
        }

        createRow(title, price, quantity) {
          const row = document.createElement('div');
          row.className = 'yg-buy-buttons__item';
          const titleElement = document.createElement('span');
          titleElement.className = 'yg-buy-buttons__item-title';
          titleElement.textContent = title;
          const meta = document.createElement('span');
          meta.className = 'yg-buy-buttons__item-meta';
          const priceElement = document.createElement('span');
          priceElement.textContent = this.formatMoney(price);
          const divider = document.createElement('span');
          divider.className = 'yg-buy-buttons__item-divider';
          divider.setAttribute('aria-hidden', 'true');
          const quantityElement = document.createElement('span');
          quantityElement.textContent = `x${quantity}`;
          meta.append(priceElement, divider, quantityElement);
          row.append(titleElement, meta);
          return row;
        }

        formatMoney(cents) {
          const defaultToken = '$' + '{' + '{' + 'amount' + '}' + '}';
          const placeholderToken = '{' + '{' + 'amount' + '}' + '}';
          const format = this.dataset.moneyFormat || defaultToken;
          const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
          const placeholder = match?.[1] || 'amount';
          const formats = {
            amount: [2, ',', '.'],
            amount_no_decimals: [0, ',', '.'],
            amount_with_comma_separator: [2, '.', ','],
            amount_no_decimals_with_comma_separator: [0, '.', ','],
            amount_with_space_separator: [2, ' ', ','],
            amount_no_decimals_with_space_separator: [0, ' ', ','],
            amount_with_apostrophe_separator: [2, "'", '.'],
          };
          const [precision, thousands, decimal] = formats[placeholder] || formats.amount;
          const effectivePrecision = Number(cents) % 100 === 0 ? 0 : precision;
          const value = (Number(cents) / 100).toFixed(effectivePrecision);
          const parts = value.split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          const formatted = effectivePrecision > 0 ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
          return format.replace(match?.[0] || placeholderToken, formatted);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this)
    }

    get $sectionEl() {
      // if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'targetEl': document.querySelector(`.${this.getAttribute('data-target-class')}`),
        'buttonLabel': this.querySelector('.yg-link-label')
      }

      return this.#sectionEl
    }
    connectedCallback() {
        if (!this.$sectionEl['targetEl']) return
        this.init()
        this.addEventListener('click', this.itemClick);
        this.$sectionEl['targetEl'].addEventListener('click', ()=>{this.init()})
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
      } else {
        target.style.height = '0px';
      }
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';
      
      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute("data-less-label")

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      // 防止重复关闭
      if (!target.hasAttribute('open')) return;

      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")

      // 从 auto 变成具体高度，再过渡到 0
      if (target.style.height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === '0px') {
        target.removeAttribute('open');
        target.style.height = '0px';
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = '0px';
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-count-down"] && !Shopify.designMode) return;
  try {
    class YGCountDown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.hasExpired = false;
    }

    connectedCallback() {
      this.targetDate = this.parseDate(this.dataset.date);

      if (!this.targetDate) {
        this.hidden = true;
        return;
      }

      this.updateCountdown();

      if (!this.hasExpired) {
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }

    parseDate(rawDate) {
      if (!rawDate) return null;

      const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
      const parsedDate = new Date(normalizedDate);

      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    clearTimer() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    get itemMap() {
      if (this._itemMap) return this._itemMap;

      this._itemMap = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      return this._itemMap;
    }

    updateCountdown() {
      const diff = this.targetDate.getTime() - Date.now();

      if (diff <= 0) {
        this.handleExpiration();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.renderValue(this.itemMap.days, days);
      this.renderValue(this.itemMap.hours, hours);
      this.renderValue(this.itemMap.minutes, minutes);
      this.renderValue(this.itemMap.seconds, seconds);
    }

    renderValue(element, value) {
      if (!element) return;
      element.textContent = String(value).padStart(2, '0');
    }

    handleExpiration() {
      if (this.hasExpired) return;

      this.hasExpired = true;
      this.clearTimer();

      if (this.dataset.endAction === 'hide_block' && this.dataset.blockId) {
        this.dispatchEvent(
          new CustomEvent('yg:announcement-block-expired', {
            bubbles: true,
            detail: {
              blockId: this.dataset.blockId
            }
          })
        );
        return;
      }

      this.hidden = true;
    }
  }

  (() => {
    const boot = () => {
      if (!window.customElements.get('yg-count-down')) {
        window.customElements.define('yg-count-down', YGCountDown);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
      #dropdownGroup;
      #transitionCleanup;
      #resizeObserver;
      static #groupRegistry = new Map();

      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.debouncedResize = this.debounce(this.handleResize, 100);
      }

      #manageGroupRegistry(action) {
        const groupID = this.dataset.group
        if (!groupID) return action === 'get' ? null : undefined

        switch (action) {
          case 'add':
            if (!YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.set(groupID, new Set())
            }
            YGDropdown.#groupRegistry.get(groupID).add(this)
            break
          case 'remove':
            if (YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.get(groupID).delete(this)
            }
            break
          case 'get':
            const groupDropdowns = YGDropdown.#groupRegistry.get(groupID)
            this.#dropdownGroup = groupDropdowns ? Array.from(groupDropdowns) : null
            return this.#dropdownGroup
        }
      }

      get dropdownGroup() {
        if (this.#dropdownGroup) return this.#dropdownGroup
        return this.#manageGroupRegistry('get')
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl

        this._sectionsEl = {
          titleContainer: this.querySelector('.yg-dropdown-title-container'),
          contentContainer: this.querySelector('.yg-dropdown-content-container'),
          content: this.querySelector('.yg-dropdown-content')
        }

        return this._sectionsEl
      }

      connectedCallback() {
          this.#manageGroupRegistry('add')

          setTimeout(() => {
            this.initDropdownState()
          }, 60);
          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.addEventListener('click', this.itemClick);
          }
          window.addEventListener('resize', this.debouncedResize);
          this.observeContentResize();
          this.setContentContainerHeight({ immediate: true });
      }

      disconnectedCallback() {
          this.#manageGroupRegistry('remove')

          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.removeEventListener('click', this.itemClick);
          }
          window.removeEventListener('resize', this.debouncedResize);
          if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = null;
          }
          this.clearTransitionCleanup();
      }

      observeContentResize() {
        const content = this.sectionsEl.content
        if (!content || typeof ResizeObserver === 'undefined') return

        if (this.#resizeObserver) {
          this.#resizeObserver.disconnect();
        }

        this.#resizeObserver = new ResizeObserver(() => {
          const contentContainer = this.sectionsEl.contentContainer
          if (!contentContainer || !this.hasAttribute('open')) return

          if (contentContainer.style.height && contentContainer.style.height !== 'auto') {
            contentContainer.style.height = `${content.scrollHeight}px`
          }
        });

        this.#resizeObserver.observe(content)
      }

      clearTransitionCleanup() {
        if (typeof this.#transitionCleanup === 'function') {
          this.#transitionCleanup();
        }
        this.#transitionCleanup = null;
      }

      registerTransitionCleanup(callback) {
        const contentContainer = this.sectionsEl.contentContainer
        if (!contentContainer) return

        this.clearTransitionCleanup()

        const handleTransitionEnd = (event) => {
          if (event.target !== contentContainer || event.propertyName !== 'height') return
          callback?.()
          this.clearTransitionCleanup()
        }

        contentContainer.addEventListener('transitionend', handleTransitionEnd)
        this.#transitionCleanup = () => {
          contentContainer.removeEventListener('transitionend', handleTransitionEnd)
        }
      }

      initDropdownState() {
        const group = this.dropdownGroup

        if (!group || !Array.isArray(group) || group.length === 0) {
          this.setContentContainerHeight({ immediate: true })
          return
        }

        if (group[0] !== this) return

        const activeDropdown = group.find((dropdown) => dropdown.hasAttribute('open'))

        group.forEach((dropdown) => {
          if (dropdown === activeDropdown) {
            dropdown.openDropdown({ skipGroup: true, immediate: true, shouldDispatch: true })
          } else {
            dropdown.closeDropdown({ immediate: true, shouldDispatch: true })
          }
        })
      }

      itemClick() {
          this.setContentContainerHeight();
          let group = this.dropdownGroup;
          if (group && Array.isArray(group) && this.hasAttribute('open')) {
            if (!this.hasAttribute('data-accordion')) {
              this.closeDropdown();
            }
            return;
          }

          this.hasAttribute('open')?this.closeDropdown():this.openDropdown();
      }

      handleResize() {
        this.setContentContainerHeight({ immediate: true });
      }

      setContentContainerHeight({ immediate = false } = {}) {
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        if (!this.hasAttribute('open')) {
          contentContainer.style.height = '0px'
          return
        }

        if (immediate) {
          contentContainer.style.height = 'auto'
          return
        }

        if (contentContainer.style.height !== 'auto') {
          contentContainer.style.height = `${content.scrollHeight}px`
        }
      }

      openDropdown({ skipGroup = false, immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        let group = this.dropdownGroup;
        if (!skipGroup && group && Array.isArray(group)) {
            group.forEach(dropdown => {
                if (dropdown !== this) {
                    dropdown.closeDropdown({ shouldDispatch: false });
                }
            });
        }

        this.setAttribute('open', '');

        if (immediate) {
          contentContainer.style.height = 'auto'
        } else {
          this.clearTransitionCleanup()
          const startHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
          contentContainer.style.height = `${startHeight}px`
          contentContainer.offsetHeight
          contentContainer.style.height = `${content.scrollHeight}px`

          this.registerTransitionCleanup(() => {
            if (this.hasAttribute('open')) {
              contentContainer.style.height = 'auto'
            }
          })
        }

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-open', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }

      closeDropdown({ immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return
        if (!this.hasAttribute('open') && !immediate) return

        this.clearTransitionCleanup()

        if (immediate) {
          this.removeAttribute('open');
          contentContainer.style.height = '0px'
          return
        }

        const currentHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
        contentContainer.style.height = `${currentHeight}px`

        contentContainer.offsetHeight
        this.removeAttribute('open');
        contentContainer.style.height = '0px'

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-close', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }
  }
  if (!window.customElements.get('yg-dropdown')) {
      window.customElements.define('yg-dropdown',YGDropdown)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-header-mobile-menu"] && !Shopify.designMode) return;
  try {
    class YGHeaderMobileMenu extends HTMLElement {
    connectedCallback() {
      this.mainDetails = this.querySelector('header-drawer > details');
      this.menuSummary = this.mainDetails?.querySelector(':scope > summary');
      this.searchInput = this.querySelector('.yg-header-mobile-menu__search-input');
      this.searchResetButton = this.querySelector('.yg-header-mobile-menu__search-reset');
      this.predictiveSearch = this.searchInput?.closest('predictive-search');
      this.handleClick = this.handleClick.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleDrawerToggle = this.handleDrawerToggle.bind(this);
      this.handleKeyup = this.handleKeyup.bind(this);
      this.addEventListener('click', this.handleClick, true);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('keyup', this.handleKeyup, true);
      this.mainDetails?.addEventListener('toggle', this.handleDrawerToggle);
      this.enableMenuWhenReady();
    }

    enableMenuWhenReady() {
      customElements.whenDefined('header-drawer').then(() => {
        if (!this.isConnected || !this.menuSummary) return;

        this.menuSummary.removeAttribute('inert');
        this.menuSummary.removeAttribute('aria-disabled');
        this.classList.add('is-ready');
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick, true);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('keyup', this.handleKeyup, true);
      this.mainDetails?.removeEventListener('toggle', this.handleDrawerToggle);
      window.clearTimeout(this.closeAnimationTimer);
    }

    handleClick(event) {
      const resetButton = event.target.closest('.yg-header-mobile-menu__search-reset');
      if (resetButton && this.contains(resetButton)) {
        event.preventDefault();
        event.stopPropagation();
        this.resetSearchState({ keepSearchMode: true });
        return;
      }

      const countryTrigger = event.target.closest('[data-yg-mobile-country]');
      if (countryTrigger && this.contains(countryTrigger)) {
        const headerDrawer = this.mainDetails.closest('header-drawer');
        this.startCloseAnimation();
        headerDrawer?.closeMenuDrawer(event, this.menuSummary);
        return;
      }

      const cancelButton = event.target.closest('[data-yg-mobile-search-cancel]');
      if (cancelButton && this.contains(cancelButton)) {
        event.preventDefault();
        event.stopPropagation();
        this.resetSearchState();
        return;
      }

      const mainSummary = event.target.closest('.header__icon--menu');
      if (mainSummary === this.menuSummary && this.mainDetails.open) {
        this.startCloseAnimation();
        this.resetSearchState();
      }

      const summary = event.target.closest('.yg-header-mobile-menu__summary');
      if (!summary || !this.contains(summary)) return;

      event.preventDefault();
      event.stopPropagation();
      const details = summary.closest('details');
      details.toggleAttribute('open');
      summary.setAttribute('aria-expanded', String(details.open));
    }

    handleFocusIn(event) {
      if (event.target === this.searchInput) {
        this.classList.add('is-searching');
      }
    }

    handleKeyup(event) {
      if (event.key === 'Escape') this.startCloseAnimation();
    }

    startCloseAnimation() {
      if (
        !this.mainDetails?.open ||
        this.mainDetails.classList.contains('is-menu-closing') ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      this.mainDetails.classList.add('is-menu-closing');
      window.clearTimeout(this.closeAnimationTimer);
      this.closeAnimationTimer = window.setTimeout(() => {
        this.mainDetails?.classList.remove('is-menu-closing');
        this.closeAnimationTimer = null;
      }, 400);
    }

    handleDrawerToggle() {
      if (!this.mainDetails.open) {
        this.mainDetails.classList.remove('is-menu-closing');
        this.resetSearchState();
      }
    }

    resetSearchState({ keepSearchMode = false } = {}) {
      if (!this.searchInput) return;

      if (this.predictiveSearch?.abortController) {
        this.predictiveSearch.abortController.abort();
        this.predictiveSearch.abortController = new AbortController();
      }

      this.searchInput.value = '';
      if (this.predictiveSearch) {
        this.predictiveSearch.searchTerm = '';
      }
      this.predictiveSearch?.closeResults?.(true);
      this.predictiveSearch?.removeAttribute('loading');
      this.predictiveSearch?.removeAttribute('open');
      this.predictiveSearch?.removeAttribute('results');
      this.searchResetButton?.classList.add('hidden');

      if (keepSearchMode) {
        this.classList.add('is-searching');
        this.searchInput.focus({ preventScroll: true });
        return;
      }

      this.searchInput.blur();
      this.classList.remove('is-searching');
    }
  }

  if (!customElements.get('yg-header-mobile-menu')) {
    customElements.define('yg-header-mobile-menu', YGHeaderMobileMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
      this.breakpointChangeHandler = () => this.applyResponsiveSrc();
      this.imageListeners = new Map();
      this.videoListeners = new Map();
      this.previewVideoTimers = new Map();
    }
    connectedCallback() {
      // 先按当前断点解析响应式图片地址，再交给懒加载观察，确保只下载一端的图片
      this.setLoadingState();
      this.applyResponsiveSrc();
      this.watchImages();
      this.watchPreviewVideos();
      this.loaderImg();
      this.loaderPreviewVideos();
      this.watchBreakpointChange();
    }
    disconnectedCallback() {
      this.breakpointQuery?.removeEventListener?.('change', this.breakpointChangeHandler);
      this.breakpointQuery?.removeListener?.(this.breakpointChangeHandler);
      this.previewVideoObserver?.disconnect();
      this.removeImageListeners();
      this.removeVideoListeners();
      this.clearPreviewVideoTimers();
    }
    get images() {
      if (this.classList.contains('yg-video-placeholder')) {
        return this.querySelectorAll('img[data-src]');
      }
      return this.querySelectorAll('img[data-src]:not([data-video-poster])');
    }
    get allImages() {
      return this.querySelectorAll('img');
    }
    get previewPosters() {
      return this.querySelectorAll('img[data-video-poster]');
    }
    get previewVideos() {
      return this.querySelectorAll('video[data-video-preview]');
    }
    get allMedia() {
      return this.querySelectorAll('img, video[data-video-preview]');
    }
    // 同时携带 pc / mobile 两个断点地址的懒加载图片
    get responsiveImages() {
      return this.querySelectorAll('img[data-src-pc][data-src-mobile]');
    }
    get responsivePreviewVideos() {
      return this.querySelectorAll('video[data-video-preview][data-src-pc][data-src-mobile]');
    }
    get isMobileBreakpoint() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 999px)').matches);
    }

    setLoadingState() {
      this.classList.add('is-loading');
      this.classList.remove('is-loaded', 'is-error', 'is-video-error');
    }

    watchImages() {
      this.allImages.forEach((img) => this.watchImage(img));
    }

    watchPreviewVideos() {
      this.previewVideos.forEach((video) => this.watchPreviewVideo(video));
    }

    watchImage(img) {
      if (this.imageListeners.has(img)) return;

      const handleLoad = () => {
        if (img.hasAttribute('data-src')) return;
        this.handleImageLoad(img);
      };
      const handleError = () => {
        if (img.hasAttribute('data-src')) return;
        this.setErrorState(img);
      };

      this.imageListeners.set(img, { handleLoad, handleError });
      img.addEventListener('load', handleLoad);
      img.addEventListener('error', handleError);

      if (img.hasAttribute('data-src') || !img.complete) return;

      if (img.naturalWidth > 0) {
        this.handleImageLoad(img);
      } else {
        this.setErrorState(img);
      }
    }

    async handleImageLoad(img) {
      if (img.classList.contains('is-loaded')) return;

      if (typeof img.decode === 'function') {
        try {
          await img.decode();
        } catch (error) {
          // A successful load can still be rendered when decode() rejects.
        }
      }

      this.setLoadedState(img);
    }

    watchPreviewVideo(video) {
      if (this.videoListeners.has(video)) return;

      const handleLoadedMetadata = () => {
        if (video.duration && video.currentTime === 0) {
          try {
            video.currentTime = Math.min(0.001, video.duration);
          } catch (error) {
            // Some browsers paint frame zero without allowing an initial seek.
          }
        }
      };
      const handleLoadedData = () => this.handlePreviewVideoFrame(video);
      const handleError = () => this.setPreviewVideoErrorState(video);

      this.videoListeners.set(video, { handleLoadedMetadata, handleLoadedData, handleError });
      video.addEventListener('loadedmetadata', handleLoadedMetadata);
      video.addEventListener('loadeddata', handleLoadedData);
      video.addEventListener('error', handleError);

      if (video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        this.handlePreviewVideoFrame(video);
      }
    }

    handlePreviewVideoFrame(video) {
      if (video.classList.contains('is-loaded')) return;

      const activeSrc = video.dataset.activeSrc;
      let fallbackTimer;
      const reveal = () => {
        window.clearTimeout(fallbackTimer);
        if (video.dataset.activeSrc !== activeSrc) return;
        if (video.classList.contains('is-loaded')) return;
        video.pause();
        this.setLoadedState(video);
      };

      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(reveal);
        fallbackTimer = window.setTimeout(reveal, 250);
      } else {
        reveal();
      }
    }

    setLoadedState(img) {
      img.classList.remove('is-error');
      img.classList.add('is-loaded');
      if (img.matches('video[data-video-preview]')) {
        this.clearPreviewVideoTimer(img);
        this.classList.remove('is-video-error');
      }
      if (!img.matches('[data-video-poster]')) {
        this.removeImageListener(img);
      }
      this.updateMediaState();
    }

    updateMediaState() {
      const previewVideo = this.previewVideos[0];
      const hasLoadedPreview = previewVideo?.classList.contains('is-loaded');
      const hasLoadedPoster =
        this.classList.contains('yg-video-placeholder') &&
        Array.from(this.previewPosters).some(
          (poster) => poster.classList.contains('is-loaded') && !poster.classList.contains('is-error')
        );
      if (hasLoadedPreview || hasLoadedPoster) {
        this.classList.remove('is-loading', 'is-error');
        if (hasLoadedPreview) this.classList.remove('is-video-error');
        this.classList.add('is-loaded');
        return;
      }

      const includePreviewPoster = !previewVideo || previewVideo.classList.contains('is-error');
      const media = Array.from(this.allMedia).filter(
        (item) => includePreviewPoster || !item.matches('[data-video-poster]')
      );
      if (!media.length) return;
      const isEveryMediaResolved = media.every(
        (item) => item.classList.contains('is-loaded') || item.classList.contains('is-error')
      );
      if (!isEveryMediaResolved) return;

      const hasLoadedMedia = media.some((item) => item.classList.contains('is-loaded'));
      this.classList.remove('is-loading', 'is-loaded', 'is-error');
      this.classList.add(hasLoadedMedia ? 'is-loaded' : 'is-error');
    }

    setErrorState(img) {
      img.classList.remove('is-loaded');
      img.classList.add('is-error');
      if (!img.matches('[data-video-poster]')) {
        this.removeImageListener(img);
      }
      this.updateMediaState();
    }

    setPreviewVideoErrorState(video) {
      this.clearPreviewVideoTimer(video);
      video.classList.remove('is-loaded');
      video.classList.add('is-error');
      this.classList.add('is-video-error');
      this.loadPreviewPosters();
      this.updateMediaState();
    }

    loadPreviewPosters() {
      this.previewPosters.forEach((poster) => {
        const src = poster.getAttribute('data-src');
        if (!src) return;

        this.loadImage(poster);
      });
    }

    startPreviewVideoTimer(video) {
      this.clearPreviewVideoTimer(video);
      const activeSrc = video.dataset.activeSrc;
      const timer = window.setTimeout(() => {
        if (video.dataset.activeSrc !== activeSrc || video.classList.contains('is-loaded')) return;
        this.setPreviewVideoErrorState(video);
      }, 8000);
      this.previewVideoTimers.set(video, timer);
    }

    clearPreviewVideoTimer(video) {
      const timer = this.previewVideoTimers.get(video);
      if (!timer) return;

      window.clearTimeout(timer);
      this.previewVideoTimers.delete(video);
    }

    clearPreviewVideoTimers() {
      this.previewVideoTimers.forEach((timer) => window.clearTimeout(timer));
      this.previewVideoTimers.clear();
    }

    removeImageListener(img) {
      const listeners = this.imageListeners.get(img);
      if (!listeners) return;

      img.removeEventListener('load', listeners.handleLoad);
      img.removeEventListener('error', listeners.handleError);
      this.imageListeners.delete(img);
    }

    removeImageListeners() {
      this.imageListeners.forEach((listeners, img) => {
        img.removeEventListener('load', listeners.handleLoad);
        img.removeEventListener('error', listeners.handleError);
      });
      this.imageListeners.clear();
    }

    removeVideoListener(video) {
      const listeners = this.videoListeners.get(video);
      if (!listeners) return;

      video.removeEventListener('loadedmetadata', listeners.handleLoadedMetadata);
      video.removeEventListener('loadeddata', listeners.handleLoadedData);
      video.removeEventListener('error', listeners.handleError);
      this.videoListeners.delete(video);
    }

    removeVideoListeners() {
      this.videoListeners.forEach((listeners, video) => {
        video.removeEventListener('loadedmetadata', listeners.handleLoadedMetadata);
        video.removeEventListener('loadeddata', listeners.handleLoadedData);
        video.removeEventListener('error', listeners.handleError);
      });
      this.videoListeners.clear();
    }

    // 依据当前断点解析响应式图片：
    // 尚未加载时改写 data-src（懒加载真正触发前生效）；已加载时切换 src。
    applyResponsiveSrc() {
      this.responsiveImages.forEach((img) => {
        const url = this.isMobileBreakpoint ? img.dataset.srcMobile : img.dataset.srcPc;
        const srcset = this.isMobileBreakpoint ? img.dataset.srcsetMobile : img.dataset.srcsetPc;
        if (!url) return;
        if (img.hasAttribute('data-src')) {
          img.setAttribute('data-src', url);
          if (srcset) img.setAttribute('data-srcset', srcset);
        } else if (img.getAttribute('src') !== url) {
          if (img.matches('[data-video-poster]')) {
            img.classList.remove('is-loaded', 'is-error');
          }
          if (srcset) img.srcset = srcset;
          img.src = url;
        }
      });

      this.responsivePreviewVideos.forEach((video) => {
        const url = this.isMobileBreakpoint ? video.dataset.srcMobile : video.dataset.srcPc;
        if (!url || video.dataset.activeSrc === url) return;

        video.dataset.activeSrc = url;
        video.classList.remove('is-loaded', 'is-error');
        this.setLoadingState();

        if (video.hasAttribute('src')) {
          video.src = url;
          video.load();
          this.startPreviewVideoTimer(video);
        } else {
          video.setAttribute('data-src', url);
        }
      });
      if (this.classList.contains('yg-video-placeholder')) this.updateMediaState();
    }

    // 跨 999px 断点时重新解析响应式图片地址
    watchBreakpointChange() {
      if (!window.matchMedia) return;
      this.breakpointQuery = window.matchMedia('(max-width: 999px)');
      if (this.breakpointQuery.addEventListener) {
        this.breakpointQuery.addEventListener('change', this.breakpointChangeHandler);
      } else if (this.breakpointQuery.addListener) {
        // 旧浏览器兜底
        this.breakpointQuery.addListener(this.breakpointChangeHandler);
      }
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }

    loaderPreviewVideos() {
      if (!this.previewVideos.length) return;

      if (!window.IntersectionObserver) {
        this.previewVideos.forEach((video) => this.loadPreviewVideo(video));
        return;
      }

      this.previewVideoObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.loadPreviewVideo(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          rootMargin: '300px 0px',
        }
      );

      this.previewVideos.forEach((video) => this.previewVideoObserver.observe(video));
    }

    loadPreviewVideo(video) {
      const src = video.getAttribute('data-src');
      if (!src) return;

      video.src = src;
      video.removeAttribute('data-src');
      video.load();
      this.startPreviewVideoTimer(video);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-main-product-model-chooser-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-product-comparison')) {
    class YGProductComparison extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          this.attachGlobalListeners();
          return;
        }
        this.initialized = true;
        this.currentProductId = this.dataset.currentProductId;
        this.fromLabel = this.dataset.fromLabel;
        this.chooseLabel = this.dataset.chooseLabel;
        this.currentSelectionLabel = this.dataset.currentSelectionLabel;
        this.selectProductLabel = this.dataset.selectProductLabel;
        this.checkImage = this.querySelector('[data-product-check-image]')?.innerHTML.trim() || '';
        this.compareTitles = Array.from(this.querySelectorAll('[data-compare-title]'), (node) =>
          node.textContent.trim()
        );
        this.products = Array.from(this.querySelectorAll('[data-product-record]'), (record) => ({
          id: record.dataset.productId,
          title: record.querySelector('[data-product-title]')?.textContent.trim() || '',
          url: record.querySelector('[data-product-url]')?.textContent.trim() || '',
          price: record.querySelector('[data-product-price]')?.textContent.trim() || '',
          description: record.querySelector('[data-product-description]')?.textContent.trim() || '',
          image: record.querySelector('[data-product-image]')?.innerHTML.trim() || '',
          values: Array.from(record.querySelectorAll('[data-product-value]'), (node) => node.textContent.trim()),
        }));
        this.selectedIds = this.products.slice(0, 3).map((item) => item.id);
        this.showDifferences = false;
        this.openDropdown = null;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.scrollContainer = this.querySelector('.yg-product-comparison__scroll');
        this.cardsContainer = this.querySelector('[data-comparison-cards]');
        this.tableHead = this.querySelector('[data-comparison-head]');
        this.handleComparisonScrollBound = () => this.updateTableHeadVisibility();
        this.handleViewportChangeBound = () => this.handleViewportChange();
        this.handleDocumentPointerDownBound = (event) => {
          if (!this.openDropdown) return;

          const clickedDropdown = event
            .composedPath()
            .some(
              (node) =>
                node instanceof Element &&
                this.contains(node) &&
                (node.matches('[data-dropdown-trigger]') || node.matches('.yg-product-comparison__menu'))
            );
          if (clickedDropdown) return;

          const dropdown = this.openDropdown;
          this.openDropdown = null;
          this.renderDropdown(dropdown);
          this.animateDropdownCaret(dropdown, false);
        };
        this.addEventListener('click', (event) => this.handleClick(event));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.openDropdown) {
            const dropdown = this.openDropdown;
            this.openDropdown = null;
            this.renderDropdown(dropdown);
            this.focusTrigger(dropdown);
          }
        });
        this.attachGlobalListeners();
        this.render();
      }

      disconnectedCallback() {
        this.detachGlobalListeners();
      }

      attachGlobalListeners() {
        if (this.globalListenersAttached) return;
        this.globalListenersAttached = true;
        this.mobileQuery.addEventListener('change', this.handleViewportChangeBound);
        this.scrollContainer?.addEventListener('scroll', this.handleComparisonScrollBound, { passive: true });
        document.addEventListener('pointerdown', this.handleDocumentPointerDownBound);
        this.setupModalController();
      }

      detachGlobalListeners() {
        if (!this.globalListenersAttached) return;
        this.globalListenersAttached = false;
        this.mobileQuery?.removeEventListener('change', this.handleViewportChangeBound);
        this.scrollContainer?.removeEventListener('scroll', this.handleComparisonScrollBound);
        document.removeEventListener('pointerdown', this.handleDocumentPointerDownBound);
        this.teardownModalController();
        if (this.pageScrollLocked) this.unlockPageScroll();
      }

      setupModalController() {
        const modal = this.closest('modal-dialog');
        if (!modal || this.controlledModal === modal) return;
        this.controlledModal = modal;
        this.originalModalShow = modal.show;
        this.originalModalHide = modal.hide;
        modal.show = (opener) => {
          if (this.mobileQuery.matches) this.showMobileDrawer(opener);
          else this.showDesktopModal(opener);
        };
        modal.hide = () => {
          if (this.mobileQuery.matches) this.hideMobileDrawer();
          else this.hideDesktopModal();
        };
        this.closeButton = modal.querySelector('[id^="ModalClose-"]');
        this.handleCloseCaptureBound = (event) => {
          if (!modal.hasAttribute('open')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.mobileQuery.matches) this.hideMobileDrawer();
          else this.hideDesktopModal();
        };
        this.closeButton?.addEventListener('click', this.handleCloseCaptureBound, true);
      }

      teardownModalController() {
        const modal = this.controlledModal;
        if (!modal) return;
        this.clearDrawerMotion();
        this.closeButton?.removeEventListener('click', this.handleCloseCaptureBound, true);
        modal.show = this.originalModalShow;
        modal.hide = this.originalModalHide;
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        this.unlockPageScroll();
        this.controlledModal = null;
        this.closeButton = null;
      }

      showDesktopModal(opener) {
        const modal = this.controlledModal;
        if (!modal || modal.hasAttribute('open')) return;
        this.resetScrollPosition();
        modal.openedBy = opener;
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        this.lockPageScroll();
        modal.setAttribute('open', '');
        trapFocus(modal, modal.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
      }

      hideDesktopModal() {
        const modal = this.controlledModal;
        if (!modal || !modal.hasAttribute('open')) return;
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        modal.removeAttribute('open');
        this.unlockPageScroll();
        removeTrapFocus(modal.openedBy);
        window.pauseAllMedia();
      }

      showMobileDrawer(opener) {
        const modal = this.controlledModal;
        if (!modal || modal.hasAttribute('open')) return;
        this.clearDrawerMotion();
        const panel = modal.querySelector('.product-popup-modal__content');
        if (!panel) return;
        this.resetScrollPosition();
        modal.openedBy = opener;
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        this.lockPageScroll();
        modal.setAttribute('open', '');
        window.pauseAllMedia();
        panel.getBoundingClientRect();
        this.drawerFrameOne = requestAnimationFrame(() => {
          this.drawerFrameTwo = requestAnimationFrame(() => {
            if (!modal.hasAttribute('open') || !this.mobileQuery.matches) return;
            modal.classList.add('is-drawer-visible');
            this.waitForDrawerTransition(
              panel,
              () => {
                if (modal.hasAttribute('open')) trapFocus(modal, modal.querySelector('[role="dialog"]'));
              },
              900
            );
          });
        });
      }

      hideMobileDrawer() {
        const modal = this.controlledModal;
        if (!modal || !modal.hasAttribute('open') || modal.classList.contains('is-drawer-closing')) return;
        const panel = modal.querySelector('.product-popup-modal__content');
        if (!panel) {
          this.finishMobileDrawerClose();
          return;
        }
        this.clearDrawerMotion();
        modal.classList.add('is-drawer-closing');
        this.waitForDrawerTransition(panel, () => this.finishMobileDrawerClose(), 700);
      }

      finishMobileDrawerClose() {
        const modal = this.controlledModal;
        if (!modal) return;
        this.clearDrawerMotion();
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        modal.removeAttribute('open');
        removeTrapFocus(modal.openedBy);
        this.unlockPageScroll();
        window.pauseAllMedia();
      }

      waitForDrawerTransition(panel, callback, timeout) {
        this.drawerPanel = panel;
        this.drawerTransitionHandler = (event) => {
          if (event.target !== panel || event.propertyName !== 'transform') return;
          this.clearDrawerMotion();
          callback();
        };
        panel.addEventListener('transitionend', this.drawerTransitionHandler);
        this.drawerTimer = window.setTimeout(() => {
          this.clearDrawerMotion();
          callback();
        }, timeout);
      }

      clearDrawerMotion() {
        cancelAnimationFrame(this.drawerFrameOne);
        cancelAnimationFrame(this.drawerFrameTwo);
        this.drawerFrameOne = null;
        this.drawerFrameTwo = null;
        if (this.drawerTimer) window.clearTimeout(this.drawerTimer);
        this.drawerTimer = null;
        if (this.drawerPanel && this.drawerTransitionHandler)
          this.drawerPanel.removeEventListener('transitionend', this.drawerTransitionHandler);
        this.drawerPanel = null;
        this.drawerTransitionHandler = null;
      }

      resetScrollPosition() {
        const scrollContainer = this.controlledModal?.querySelector('.yg-product-comparison__scroll');
        if (!scrollContainer) return;
        scrollContainer.scrollTop = 0;
        scrollContainer.scrollLeft = 0;
        this.updateTableHeadVisibility();
      }

      updateTableHeadVisibility() {
        if (!this.scrollContainer || !this.cardsContainer || !this.tableHead) return;
        const cardsHaveScrolledAway =
          this.scrollContainer.scrollTop > 0 &&
          this.cardsContainer.getBoundingClientRect().bottom <= this.scrollContainer.getBoundingClientRect().top + 1;
        this.tableHead.classList.toggle('is-visible', cardsHaveScrolledAway);
        this.tableHead.setAttribute('aria-hidden', String(!cardsHaveScrolledAway));
        this.tableHead.toggleAttribute('inert', !cardsHaveScrolledAway);
      }

      lockPageScroll() {
        if (this.pageScrollLocked) return;
        this.pageScrollLocked = true;
        document.documentElement.classList.add('yg-product-comparison-scroll-lock');
      }

      unlockPageScroll() {
        if (!this.pageScrollLocked) return;
        this.pageScrollLocked = false;
        document.documentElement.classList.remove('yg-product-comparison-scroll-lock');
      }

      get activeCount() {
        return Math.min(this.mobileQuery.matches ? 2 : 3, this.products.length);
      }

      get activeProducts() {
        return this.selectedIds
          .slice(0, this.activeCount)
          .map((id) => this.productById(id))
          .filter(Boolean);
      }

      productById(id) {
        return this.products.find((item) => item.id === id);
      }

      handleViewportChange() {
        if (!this.mobileQuery.matches && this.products.length > 2) {
          const used = new Set(this.selectedIds.slice(0, 2));
          if (!this.selectedIds[2] || used.has(this.selectedIds[2])) {
            this.selectedIds[2] = this.products.find((item) => !used.has(item.id))?.id;
          }
        }
        this.openDropdown = null;
        this.render();
        const modal = this.closest('modal-dialog');
        if (modal?.hasAttribute('open')) {
          this.clearDrawerMotion();
          modal.classList.remove('is-drawer-closing');
          modal.classList.toggle('is-drawer-visible', this.mobileQuery.matches);
        }
      }

      handleClick(event) {
        const specialist = event.target.closest('[data-product-comparison-specialist]');
        if (specialist) {
          if (typeof window.zE === 'function') {
            window.zE('messenger', 'open');
          } else {
            console.warn('Zendesk Web Widget is not available.');
          }
          return;
        }

        const trigger = event.target.closest('[data-dropdown-trigger]');
        if (trigger) {
          const nextDropdown = `${trigger.dataset.scope}:${trigger.dataset.slot}`;
          const previousDropdown = this.openDropdown;
          this.openDropdown = previousDropdown === nextDropdown ? null : nextDropdown;
          new Set([previousDropdown, nextDropdown]).forEach((dropdown) => this.renderDropdown(dropdown));
          if (previousDropdown && previousDropdown !== this.openDropdown) {
            this.animateDropdownCaret(previousDropdown, false);
          }
          if (this.openDropdown) {
            this.animateDropdownCaret(this.openDropdown, true);
          }
          if (this.openDropdown) this.querySelector('.yg-product-comparison__option.is-selected')?.focus();
          else this.focusTrigger(nextDropdown);
          return;
        }
        const option = event.target.closest('[data-product-option]');
        if (option && !option.disabled) {
          const dropdown = this.openDropdown;
          this.selectedIds[Number(option.dataset.slot)] = option.dataset.productId;
          this.openDropdown = null;
          this.render();
          this.focusTrigger(dropdown);
          return;
        }
        if (event.target.closest('[data-difference-toggle]')) {
          const dropdown = this.openDropdown;
          this.showDifferences = !this.showDifferences;
          this.openDropdown = null;
          this.renderDropdown(dropdown);
          this.renderDifferences();
        }
      }

      escape(value) {
        return String(value ?? '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');
      }

      focusTrigger(dropdown) {
        if (!dropdown) return;
        const [scope, slot] = dropdown.split(':');
        this.querySelector(`[data-dropdown-trigger][data-scope="${scope}"][data-slot="${slot}"]`)?.focus();
      }

      animateDropdownCaret(dropdown, expanded) {
        if (!dropdown || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const [scope, slot] = dropdown.split(':');
        const selector = `[data-dropdown-trigger][data-scope="${scope}"][data-slot="${slot}"] .yg-product-comparison__caret`;
        const startRotation = expanded ? 'rotate(0deg)' : 'rotate(180deg)';
        const endRotation = expanded ? 'rotate(180deg)' : 'rotate(0deg)';

        this.querySelectorAll(selector).forEach((caret) => {
          caret.animate([{ transform: startRotation }, { transform: endRotation }], {
            duration: 200,
            easing: 'ease',
          });
        });
      }

      caretIcon(dark) {
        const stroke = dark ? 'white' : '#2E2E2E';
        return `
          <svg
            class="yg-product-comparison__caret"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M5 7.5L10 12.5L15 7.5"
              stroke="${stroke}"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        `;
      }

      dropdown(scope, slot, product, dark = false) {
        const key = `${scope}:${slot}`;
        const selectedIds = new Set(this.activeProducts.map((item) => item.id));
        const menu =
          this.openDropdown === key
            ? `<div class="yg-product-comparison__menu" role="listbox">${this.products
                .map((item) => {
                  const selected = item.id === product.id;
                  const disabled = !selected && selectedIds.has(item.id);
                  const checkmark = selected ? this.checkImage : '';

                  return `
                    <button
                      type="button"
                      class="yg-product-comparison__option${selected ? ' is-selected' : ''}"
                      role="option"
                      aria-selected="${selected}"
                      data-product-option
                      data-product-id="${this.escape(item.id)}"
                      data-slot="${slot}"
                      ${disabled ? 'disabled' : ''}
                    >
                      <span>${this.escape(item.title)}</span>
                      ${checkmark}
                    </button>
                  `;
                })
                .join('')}</div>`
            : '';
        const content = dark
          ? `
            <span>
              <span class="yg-product-comparison__head-title">
                ${this.escape(product.title)}
              </span>
              <span class="yg-product-comparison__head-price">
                <span>${this.escape(this.fromLabel)}</span>
                ${this.escape(product.price)}
              </span>
            </span>
          `
          : `<strong>${this.escape(product.title)}</strong>`;
        const triggerClass = dark ? 'yg-product-comparison__head-trigger' : 'yg-product-comparison__select-trigger';

        return `
          <div class="yg-product-comparison__select">
            <button
              type="button"
              class="${triggerClass}"
              aria-label="${this.escape(this.selectProductLabel)}"
              aria-haspopup="listbox"
              aria-expanded="${this.openDropdown === key}"
              data-dropdown-trigger
              data-scope="${scope}"
              data-slot="${slot}"
            >
              ${content}
              ${this.caretIcon(dark)}
            </button>
            ${menu}
          </div>
        `;
      }

      chooseButton(product) {
        if (product.id === this.currentProductId) {
          return `
            <button
              type="button"
              class="yg-product-comparison__choose is-current"
              disabled
              aria-current="page"
            >
              ${this.escape(this.currentSelectionLabel)}
            </button>
          `;
        }

        return `
          <a
            class="yg-product-comparison__choose"
            href="${this.escape(product.url)}"
          >
            ${this.escape(this.chooseLabel)}
          </a>
        `;
      }

      renderCards(products) {
        return products
          .map((product, slot) => {
            const cardClass = product.id === this.currentProductId ? ' is-current' : '';
            const media = product.image
              ? product.image
              : `
                <span
                  class="yg-product-comparison__placeholder"
                  aria-hidden="true"
                ></span>
              `;
            const description = product.description
              ? `
                <p class="yg-product-comparison__description">
                  ${this.escape(product.description)}
                </p>
              `
              : '';

            return `
              <article class="yg-product-comparison__card${cardClass}">
                ${this.dropdown('card', slot, product)}
                <div class="yg-product-comparison__card-content">
                  <div class="yg-product-comparison__summary">
                    <div class="yg-product-comparison__media">
                      ${media}
                    </div>
                    <div class="yg-product-comparison__copy">
                      ${description}
                      <p class="yg-product-comparison__price">
                        <span>${this.escape(this.fromLabel)}</span>
                        ${this.escape(product.price)}
                      </p>
                    </div>
                  </div>
                  ${this.chooseButton(product)}
                </div>
              </article>
            `;
          })
          .join('');
      }

      renderHead(products) {
        return products
          .map(
            (product, slot) =>
              `<div class="yg-product-comparison__head-cell">${this.dropdown('head', slot, product, true)}</div>`
          )
          .join('');
      }

      comparisonValue(product, index) {
        const value = product.values[index]?.trim();
        return value || '—';
      }

      rowIsDifferent(products, index) {
        return new Set(products.map((product) => this.comparisonValue(product, index).trim())).size > 1;
      }

      renderRows(products) {
        return this.compareTitles
          .map((title, index) => {
            if (this.showDifferences && !this.rowIsDifferent(products, index)) return '';
            const columns = products
              .map((product, slot) => {
                const rowTitle =
                  slot === 0
                    ? `
                      <p class="yg-product-comparison__row-title">
                        ${this.escape(title)}
                      </p>
                    `
                    : `
                      <span
                        class="yg-product-comparison__row-title-spacer"
                        aria-hidden="true"
                      ></span>
                    `;

                return `
                  <div
                    class="yg-product-comparison__row-column"
                    data-slot="${slot}"
                  >
                    ${rowTitle}
                    <div class="yg-product-comparison__row-value">
                      ${this.escape(this.comparisonValue(product, index))}
                    </div>
                  </div>
                `;
              })
              .join('');

            return `
              <div class="yg-product-comparison__row">
                <div class="yg-product-comparison__row-values">
                  ${columns}
                </div>
              </div>
            `;
          })
          .join('');
      }

      renderDropdown(dropdown) {
        if (!dropdown) return;
        const [scope, slotValue] = dropdown.split(':');
        const slot = Number(slotValue);
        const product = this.activeProducts[slot];
        const trigger = this.querySelector(`[data-dropdown-trigger][data-scope="${scope}"][data-slot="${slot}"]`);
        const select = trigger?.closest('.yg-product-comparison__select');
        if (product && select) select.outerHTML = this.dropdown(scope, slot, product, scope === 'head');
      }

      renderDifferences(products = this.activeProducts) {
        this.querySelector('[data-comparison-body]').innerHTML = this.renderRows(products);
        this.querySelector('[data-difference-toggle]').setAttribute('aria-checked', String(this.showDifferences));
        this.updateTableHeadVisibility();
      }

      render() {
        const products = this.activeProducts;
        this.style.setProperty('--yg-compare-columns', products.length || 1);
        this.querySelector('[data-comparison-cards]').innerHTML = this.renderCards(products);
        this.querySelector('[data-comparison-head]').innerHTML = this.renderHead(products);
        this.querySelector('[data-comparison-actions]').innerHTML = products
          .map(
            (product, slot) =>
              `<div class="yg-product-comparison__table-action-cell" data-slot="${slot}">${this.chooseButton(
                product
              )}</div>`
          )
          .join('');
        this.renderDifferences(products);
      }
    }
    customElements.define('yg-product-comparison', YGProductComparison);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-member-benefits-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-member-benefits-content')) {
    customElements.define(
      'yg-member-benefits-content',
      class YGMemberBenefitsContent extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          this.initialized = true;
          this.modal = this.closest('modal-dialog');
          this.dialog = this.closest('[role="dialog"]');
          this.copy = this.querySelector('.yg-member-benefits-modal__copy');
          this.formState = this.querySelector('[data-member-benefits-form-state]');
          this.successState = this.querySelector('[data-member-benefits-success-state]');
          this.continueButton = this.querySelector('[data-member-benefits-continue]');
          this.klaviyoSlot = this.querySelector('[data-member-benefits-klaviyo-slot]');
          this.initializedKlaviyoCheckboxes = new WeakSet();
          this.formId = String(this.dataset.formId || '').trim();
          this.storageKey = this.formId ? `yg-member-benefits:${this.formId}:submitted` : '';
          this.onKlaviyoForm = this.handleKlaviyoForm.bind(this);
          this.onContinue = () => this.modal?.hide();
          this.onModalChange = (entries) => {
            if (entries.some((entry) => entry.attributeName === 'open') && this.modal?.hasAttribute('open')) {
              this.setSuccess(this.hasSubmitted());
              this.queueKlaviyoCheckboxDefaults();
            }
          };

          window.addEventListener('klaviyoForms', this.onKlaviyoForm);
          this.continueButton?.addEventListener('click', this.onContinue);
          this.modalObserver = new MutationObserver(this.onModalChange);
          if (this.modal) this.modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
          this.copyObserver = new ResizeObserver(() => this.syncHeight());
          if (this.copy) this.copyObserver.observe(this.copy);
          this.klaviyoObserver = new MutationObserver(() => this.queueKlaviyoCheckboxDefaults());
          if (this.klaviyoSlot) {
            this.klaviyoObserver.observe(this.klaviyoSlot, { childList: true, subtree: true });
          }
          this.setSuccess(this.hasSubmitted());
          this.queueKlaviyoCheckboxDefaults();
          requestAnimationFrame(() => this.syncHeight());
        }

        disconnectedCallback() {
          window.removeEventListener('klaviyoForms', this.onKlaviyoForm);
          this.continueButton?.removeEventListener('click', this.onContinue);
          this.modalObserver?.disconnect();
          this.copyObserver?.disconnect();
          this.klaviyoObserver?.disconnect();
          cancelAnimationFrame(this.klaviyoCheckboxFrame);
          this.initialized = false;
        }

        queueKlaviyoCheckboxDefaults() {
          cancelAnimationFrame(this.klaviyoCheckboxFrame);
          this.klaviyoCheckboxFrame = requestAnimationFrame(() => this.applyKlaviyoCheckboxDefaults());
        }

        applyKlaviyoCheckboxDefaults() {
          const checkboxes = this.klaviyoSlot?.querySelectorAll('input[type="checkbox"]') || [];
          const checkedSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked')?.set;

          checkboxes.forEach((checkbox) => {
            if (this.initializedKlaviyoCheckboxes.has(checkbox)) return;

            this.initializedKlaviyoCheckboxes.add(checkbox);
            if (checkbox.checked) return;

            if (checkedSetter) {
              checkedSetter.call(checkbox, true);
            } else {
              checkbox.checked = true;
            }
            checkbox.setAttribute('checked', '');
            checkbox.dispatchEvent(new Event('input', { bubbles: true }));
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        handleKlaviyoForm(event) {
          const detail = event.detail || {};
          const submittedFormId = String(detail.formId || detail.formID || '').trim();
          if (!this.formId || detail.type !== 'submit' || submittedFormId !== this.formId) return;

          this.rememberSubmission();
          this.setSuccess(true);
          requestAnimationFrame(() => this.continueButton?.focus({ preventScroll: true }));
        }

        hasSubmitted() {
          if (!this.storageKey) return false;

          try {
            return localStorage.getItem(this.storageKey) === 'true';
          } catch (error) {
            return false;
          }
        }

        rememberSubmission() {
          if (!this.storageKey) return;

          try {
            localStorage.setItem(this.storageKey, 'true');
          } catch (error) {
            return;
          }
        }

        syncHeight() {
          if (!this.copy || window.matchMedia('(max-width: 999px)').matches) {
            this.style.removeProperty('--yg-member-shell-height');
            return;
          }

          const copyHeight = Math.ceil(this.copy.getBoundingClientRect().height);
          if (copyHeight > 0) this.style.setProperty('--yg-member-shell-height', `${copyHeight}px`);
        }

        setSuccess(isSuccess) {
          this.classList.toggle('is-success', isSuccess);
          this.dialog?.classList.toggle('is-success', isSuccess);
          this.formState?.setAttribute('aria-hidden', String(isSuccess));
          this.successState?.setAttribute('aria-hidden', String(!isSuccess));
          requestAnimationFrame(() => this.syncHeight());
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-media-gallery-mondo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mondo-media-gallery-controls')) {
    customElements.define(
      'mondo-media-gallery-controls',
      class MondoMediaGalleryControls extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.gallery = this.closest('media-gallery');
          this.sticky = this.closest('.product__column-sticky');
          if (!this.gallery) return;
          this.viewer = this.gallery.querySelector('[id^="GalleryViewer"]');
          this.thumbnailSlider = this.gallery.querySelector('[id^="GalleryThumbnails"]');
          this.thumbnailSlot = this.querySelector('[data-mondo-thumbnail-slot]');
          this.thumbnailEndLines = this.querySelector('[data-mondo-thumbnail-end-lines]');
          this.overflowCount = this.querySelector('[data-mondo-overflow-count]');
          this.previousButton = this.querySelector('[data-mondo-previous]');
          this.nextButton = this.querySelector('[data-mondo-next]');
          this.breakpoint = window.matchMedia('(min-width: 1000px)');
          this.activeMediaIds = { desktop: null, mobile: null };
          this.viewportUpdateFrame = null;
          this.modalPlaybackResumeFrame = null;
          this.modalViewportResumeFrame = null;
          this.viewportWidth = window.innerWidth;
          this.stickyAddToCartHeightMeasurementScheduled = false;
          this.sticky.style.setProperty('--mondo-sticky-atc-default-height', '0px');
          this.scheduleViewportUpdate = this.scheduleViewportUpdate.bind(this);
          this.handleModalClosed = () => {
            if (this.modalPlaybackResumeFrame !== null) {
              window.cancelAnimationFrame(this.modalPlaybackResumeFrame);
            }
            this.modalPlaybackResumeFrame = window.requestAnimationFrame(() => {
              this.modalPlaybackResumeFrame = null;
              const openModal = document.querySelector(
                'modal-dialog[open], quick-add-modal[open], cart-disclosure-modal[open], dialog[open]'
              );
              if (!this.isConnected || openModal) return;
              this.syncFromActiveSlide();
            });
          };
          this.handleBreakpointChange = () => {
            const shouldResumeModal = this.modal?.hasAttribute('open');
            this.updateThumbnailPlacement();
            this.syncFromActiveSlide();
            if (shouldResumeModal) {
              this.scheduleModalMediaResume();
            } else {
              this.resetModalMedia();
            }
            this.scheduleStickyAddToCartHeightMeasurement();
          };
          this.setupAnimationSlide();
          this.setupButtonBackgroundLoop();
          if (this.thumbnailSlider) {
            this.thumbnailMarker = document.createComment('mondo-thumbnail-position');
            this.thumbnailSlider.parentNode.insertBefore(this.thumbnailMarker, this.thumbnailSlider);
          }
          this.previousButton?.addEventListener('click', () => {
            this.cancelAnimationReturn();
            this.move(-1);
          });
          this.nextButton?.addEventListener('click', () => {
            this.cancelAnimationReturn();
            this.move(1);
          });
          this.thumbnailSlider?.addEventListener(
            'click',
            () => {
              this.cancelAnimationReturn();
            },
            true
          );
          this.viewer?.addEventListener('slideChanged', (event) => {
            this.activeMediaId = event.detail?.currentElement?.dataset?.mediaId;
            const isIntroAnimationSlide =
              this.animationReturnPending && this.activeMediaId === this.animationSlide?.dataset.mediaId;
            if (this.animationReturnPending && !isIntroAnimationSlide) {
              this.cancelAnimationReturn();
            } else if (
              !isIntroAnimationSlide &&
              !this.animationAutoSwitching &&
              this.activeMediaId !== this.initialMediaId
            ) {
              this.userNavigatedGallery = true;
            }
            this.updateGalleryState();
            if (!this.breakpoint.matches) this.syncActiveThumbnail();
          });
          this.breakpoint.addEventListener('change', this.handleBreakpointChange);
          window.addEventListener('resize', this.scheduleViewportUpdate, { passive: true });
          document.body.addEventListener('modalClosed', this.handleModalClosed);
          this.slideObserver = new MutationObserver(() => this.syncFromActiveSlide());
          this.getSlides().forEach((slide) =>
            this.slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] })
          );
          this.updateThumbnailPlacement();
          this.syncFromActiveSlide();
          this.setupModal();
          this.scheduleStickyAddToCartHeightMeasurement();
        }

        disconnectedCallback() {
          this.slideObserver?.disconnect();
          this.modalObserver?.disconnect();
          this.buttonBackgroundObserver?.disconnect();
          this.breakpoint?.removeEventListener('change', this.handleBreakpointChange);
          window.removeEventListener('resize', this.scheduleViewportUpdate);
          document.body.removeEventListener('modalClosed', this.handleModalClosed);
          if (this.viewportUpdateFrame !== null) window.cancelAnimationFrame(this.viewportUpdateFrame);
          if (this.modalPlaybackResumeFrame !== null) window.cancelAnimationFrame(this.modalPlaybackResumeFrame);
          if (this.modalViewportResumeFrame !== null) window.cancelAnimationFrame(this.modalViewportResumeFrame);
          window.clearTimeout(this.animationReadyFallback);
          window.clearTimeout(this.animationAutoSwitchTimer);
          this.animationMedia?.removeEventListener('ended', this.handleAnimationMediaEnded);
          document.removeEventListener('touchstart', this.handleModalTouchStart, true);
          document.removeEventListener('touchmove', this.handleModalTouchMove, true);
          document.removeEventListener('touchend', this.handleModalTouchEnd, true);
          document.removeEventListener('touchcancel', this.handleModalTouchEnd, true);
          document.removeEventListener('wheel', this.handleModalWheel, true);
          window.removeEventListener('scroll', this.handleModalScroll);
        }

        scheduleViewportUpdate() {
          if (this.viewportUpdateFrame !== null) return;
          this.viewportUpdateFrame = window.requestAnimationFrame(() => {
            this.viewportUpdateFrame = null;
            const viewportWidth = window.innerWidth;
            const viewportWidthChanged = viewportWidth !== this.viewportWidth;
            this.viewportWidth = viewportWidth;
            this.thumbnailSlider?.resetPages?.();
            this.syncFromActiveSlide();
            if (viewportWidthChanged) {
              if (this.modal?.hasAttribute('open')) this.scheduleModalMediaResume();
              this.scheduleStickyAddToCartHeightMeasurement();
            }
          });
        }

        scheduleModalMediaResume() {
          if (this.modalViewportResumeFrame !== null) {
            window.cancelAnimationFrame(this.modalViewportResumeFrame);
          }
          this.modalViewportResumeFrame = window.requestAnimationFrame(() => {
            this.modalViewportResumeFrame = null;
            if (this.modal?.hasAttribute('open')) this.activateModalMedia();
          });
        }

        scheduleStickyAddToCartHeightMeasurement() {
          if (this.stickyAddToCartHeightMeasurementScheduled || !this.breakpoint.matches) return;

          this.stickyAddToCartHeightMeasurementScheduled = true;
          const domReady =
            document.readyState === 'loading'
              ? new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve, { once: true }))
              : Promise.resolve();

          domReady
            .then(() => document.fonts?.ready)
            .then(() => new Promise((resolve) => window.requestAnimationFrame(resolve)))
            .then(() => {
              this.stickyAddToCartHeightMeasurementScheduled = false;
              if (this.breakpoint.matches) this.measureStickyAddToCartHeight();
            });
        }

        measureStickyAddToCartHeight() {
          if (!this.isConnected || !this.gallery) return;

          const sectionId = this.dataset.sectionId;
          const escapedSectionId = sectionId ? CSS.escape(sectionId) : '';
          const stickyAddToCart = sectionId
            ? document.querySelector(`product-sticky-add-to-cart[data-section-id=${escapedSectionId}]`)
            : null;
          if (!stickyAddToCart) return;

          const wasHidden = stickyAddToCart.hidden;
          const wasExpanded = stickyAddToCart.classList.contains('is-expanded');
          const originalStyle = stickyAddToCart.getAttribute('style');

          stickyAddToCart.classList.remove('is-expanded');
          stickyAddToCart.hidden = false;
          stickyAddToCart.style.setProperty('visibility', 'hidden', 'important');
          stickyAddToCart.style.setProperty('pointer-events', 'none', 'important');
          stickyAddToCart.style.setProperty('transition', 'none', 'important');

          const height = Math.ceil(stickyAddToCart.getBoundingClientRect().height);

          stickyAddToCart.hidden = wasHidden;
          stickyAddToCart.classList.toggle('is-expanded', wasExpanded);
          if (originalStyle === null) {
            stickyAddToCart.removeAttribute('style');
          } else {
            stickyAddToCart.setAttribute('style', originalStyle);
          }

          if (height > 0) {
            this.sticky.style.setProperty('--mondo-sticky-atc-default-height', `${height}px`);
          }
        }

        setupAnimationSlide() {
          const animationMediaId = this.dataset.animationMediaId;
          const slides = this.getSlides();
          if (!animationMediaId || slides.length < 2) return;

          const animationSlide = slides.find((slide) => slide.dataset.mediaId === animationMediaId);
          const firstSlide = slides[0];
          if (!animationSlide || animationSlide === firstSlide) return;

          this.initialMediaId = firstSlide.dataset.mediaId;
          this.animationSlide = animationSlide;
          this.animationFirstSlideStartedAt = performance.now();

          if (slides[1] !== animationSlide) {
            animationSlide.parentNode.insertBefore(animationSlide, slides[1]);
          }

          const thumbnailList = this.thumbnailSlider?.querySelector('[id^="Slider-Thumbnails"]');
          const animationThumbnail = thumbnailList?.querySelector(`[data-target="${animationMediaId}"]`);
          if (animationThumbnail && thumbnailList.children[1] !== animationThumbnail) {
            thumbnailList.insertBefore(animationThumbnail, thumbnailList.children[1] || null);
          }

          requestAnimationFrame(() => {
            this.viewer?.resetPages?.();
            this.thumbnailSlider?.resetPages?.();
          });

          this.preloadAnimationSlide(animationSlide);
        }

        preloadAnimationSlide(animationSlide) {
          const deferredMedia = animationSlide.querySelector('deferred-media');
          if (!deferredMedia) return;

          deferredMedia.loadContent?.(false);
          const animationMedia = deferredMedia.querySelector('video, iframe');
          if (!animationMedia) return;

          if (animationMedia instanceof HTMLVideoElement) {
            this.animationMedia = animationMedia;
            this.handleAnimationMediaEnded = () => this.returnFromAnimationSlide();
            animationMedia.addEventListener('ended', this.handleAnimationMediaEnded);
            animationMedia.preload = 'auto';
            animationMedia.setAttribute('preload', 'auto');
            animationMedia.fetchPriority = 'high';
            animationMedia.setAttribute('fetchpriority', 'high');
            animationMedia.muted = true;
            animationMedia.defaultMuted = true;
            animationMedia.playsInline = true;
            animationMedia.pause();

            const showAnimation = () => this.autoShowAnimationSlide(animationSlide, animationMedia);
            if (animationMedia.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
              requestAnimationFrame(showAnimation);
            } else {
              animationMedia.addEventListener('canplay', showAnimation, { once: true });
              animationMedia.load();
            }

            this.animationReadyFallback = window.setTimeout(() => {
              if (animationMedia.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) showAnimation();
            }, 8000);
            return;
          }

          animationMedia.loading = 'eager';
          animationMedia.fetchPriority = 'high';
          animationMedia.setAttribute('fetchpriority', 'high');
          animationMedia.addEventListener('load', () => this.autoShowAnimationSlide(animationSlide, animationMedia), {
            once: true,
          });
        }

        autoShowAnimationSlide(animationSlide, animationMedia) {
          if (this.animationAutoSwitched || this.userNavigatedGallery || !this.isCustomBreakpoint()) return;
          const currentMediaId = this.activeMediaId || this.initialMediaId;
          if (currentMediaId !== this.initialMediaId) return;

          const minimumDisplayTime = Number(this.dataset.animationFirstSlideDelay) || 3000;
          const elapsedDisplayTime = performance.now() - this.animationFirstSlideStartedAt;
          const remainingDisplayTime = Math.max(0, minimumDisplayTime - elapsedDisplayTime);
          if (remainingDisplayTime > 0) {
            if (this.animationAutoSwitchTimer) return;
            this.animationAutoSwitchTimer = window.setTimeout(() => {
              this.animationAutoSwitchTimer = null;
              this.autoShowAnimationSlide(animationSlide, animationMedia);
            }, remainingDisplayTime);
            return;
          }

          this.animationAutoSwitched = true;
          this.animationReturnPending = animationMedia instanceof HTMLVideoElement;
          this.animationAutoSwitching = true;
          this.activeMediaId = animationSlide.dataset.mediaId;
          this.gallery.setActiveMedia?.(this.activeMediaId, false, false);
          this.updateGalleryState();

          requestAnimationFrame(() => {
            if (animationMedia instanceof HTMLVideoElement) {
              try {
                animationMedia.currentTime = 0;
              } catch (error) {
                /* Playback can still start normally. */
              }
              animationMedia.play().catch(() => undefined);
            }
            this.animationAutoSwitching = false;
          });
        }

        cancelAnimationReturn() {
          this.userNavigatedGallery = true;
          if (!this.animationReturnPending) return;

          this.animationReturnPending = false;
          this.restoreAnimationMediaLoop();
        }

        returnFromAnimationSlide() {
          if (
            !this.animationReturnPending ||
            this.userNavigatedGallery ||
            this.activeMediaId !== this.animationSlide?.dataset.mediaId
          )
            return;

          this.animationReturnPending = false;
          this.restoreAnimationMediaLoop();
          this.animationAutoSwitching = true;
          this.activeMediaId = this.initialMediaId;
          this.gallery.setActiveMedia?.(this.initialMediaId, false, false);
          this.updateGalleryState();

          requestAnimationFrame(() => {
            this.animationAutoSwitching = false;
          });
        }

        restoreAnimationMediaLoop() {
          if (!this.animationMedia) return;

          const shouldLoop = this.dataset.videoLooping === 'true';
          this.animationMedia.loop = shouldLoop;
          this.animationMedia.toggleAttribute('loop', shouldLoop);
        }

        setupButtonBackgroundLoop() {
          this.buttonBackground = this.querySelector('.mondo-gallery__video-background');
          if (!this.buttonBackground) return;

          this.enforceButtonBackgroundLoop();
          this.buttonBackgroundObserver = new MutationObserver(() => this.enforceButtonBackgroundLoop());
          this.buttonBackgroundObserver.observe(this.buttonBackground, { childList: true, subtree: true });
        }

        enforceButtonBackgroundLoop() {
          this.buttonBackground?.querySelectorAll('video').forEach((video) => {
            video.loop = true;
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.setAttribute('loop', 'loop');
            video.setAttribute('muted', 'muted');
            video.setAttribute('playsinline', 'playsinline');

            if (video.dataset.mondoLoopBound === 'true') return;
            video.dataset.mondoLoopBound = 'true';
            video.addEventListener('ended', () => {
              video.currentTime = 0;
              video.play().catch(() => undefined);
            });
            video.play().catch(() => undefined);
          });
        }

        isCustomBreakpoint() {
          return this.breakpoint.matches
            ? this.gallery.dataset.mondoDesktop === 'true'
            : this.gallery.dataset.mondoMobile === 'true';
        }

        getCurrentScope() {
          return this.breakpoint.matches ? 'desktop' : 'mobile';
        }

        matchesCurrentScope(item) {
          const scope = item.dataset.mondoMediaScope || 'shared';
          return scope === 'shared' || scope === this.getCurrentScope();
        }

        updateThumbnailPlacement() {
          if (!this.thumbnailSlider || !this.thumbnailMarker) return;
          if (this.isCustomBreakpoint()) {
            this.thumbnailSlot?.appendChild(this.thumbnailSlider);
          } else if (this.thumbnailMarker.parentNode) {
            this.thumbnailMarker.parentNode.insertBefore(this.thumbnailSlider, this.thumbnailMarker.nextSibling);
            this.resetThumbnails();
          }
        }

        getSlides() {
          return Array.from(this.gallery.querySelectorAll('[id^="Slider-Gallery"] > li[data-media-id]')).filter(
            (item) => this.matchesCurrentScope(item)
          );
        }

        getAllThumbnails() {
          if (!this.thumbnailSlider) return [];
          return Array.from(this.thumbnailSlider.querySelectorAll('li[data-target]')).filter(
            (item, index) => !item.classList.contains('thumbnail-list_item--variant') || index === 0
          );
        }

        getThumbnails() {
          return this.getAllThumbnails().filter((item) => this.matchesCurrentScope(item));
        }

        syncActiveThumbnail() {
          if (!this.activeMediaId || !this.thumbnailSlider || !this.isCustomBreakpoint()) return;
          const activeThumbnail = this.thumbnailSlider.querySelector(`li[data-target='${this.activeMediaId}']`);
          this.gallery.setActiveThumbnail?.(activeThumbnail);
        }

        syncFromActiveSlide() {
          const slides = this.getSlides();
          if (!slides.length) return;
          const currentScope = this.getCurrentScope();
          let activeSlide = slides.find((slide) => slide.classList.contains('is-active'));
          if (!activeSlide && this.activeMediaIds[currentScope]) {
            activeSlide = slides.find((slide) => slide.dataset.mediaId === this.activeMediaIds[currentScope]);
          }
          if (!activeSlide) activeSlide = slides[0];
          this.activeMediaId = activeSlide.dataset.mediaId;
          this.activeMediaIds[currentScope] = this.activeMediaId;
          const globalActiveSlide = this.gallery.querySelector('[id^="Slider-Gallery"] > li.is-active[data-media-id]');
          if (this.isCustomBreakpoint() && globalActiveSlide !== activeSlide) {
            this.gallery.setActiveMedia?.(this.activeMediaId, false, false);
          }
          this.updateGalleryState();
        }

        updateGalleryState() {
          if (!this.isCustomBreakpoint()) return;
          const slides = this.getSlides();
          const activeIndex = Math.max(
            0,
            slides.findIndex((slide) => slide.dataset.mediaId === this.activeMediaId)
          );
          this.activeMediaIds[this.getCurrentScope()] = slides[activeIndex]?.dataset.mediaId || null;
          if (this.previousButton) this.previousButton.disabled = activeIndex <= 0;
          if (this.nextButton) this.nextButton.disabled = activeIndex >= slides.length - 1;
          this.updateThumbnails(activeIndex);
          this.syncActiveSlidePlayback(slides, activeIndex);
        }

        syncActiveSlidePlayback(slides, activeIndex) {
          const activeSlide = slides[activeIndex];
          slides.forEach((slide, index) => {
            if (index === activeIndex) return;
            slide.querySelectorAll('video').forEach((video) => video.pause());
          });
          const deferredMedia = activeSlide?.querySelector('deferred-media');
          deferredMedia?.loadContent?.(false);
          window.requestAnimationFrame(() => {
            const activeVideo = activeSlide?.querySelector('video');
            if (activeVideo) {
              const isIntroAnimationPlayback =
                this.animationReturnPending && activeSlide === this.animationSlide && !this.userNavigatedGallery;
              const shouldLoop = !isIntroAnimationPlayback && this.dataset.videoLooping === 'true';
              activeVideo.loop = shouldLoop;
              activeVideo.muted = true;
              activeVideo.defaultMuted = true;
              activeVideo.playsInline = true;
              if (shouldLoop) {
                activeVideo.setAttribute('loop', 'loop');
              } else {
                activeVideo.removeAttribute('loop');
              }
              activeVideo.setAttribute('muted', 'muted');
              activeVideo.setAttribute('playsinline', 'playsinline');
              activeVideo.play().catch(() => undefined);
            }
            activeSlide
              ?.querySelector('.js-youtube')
              ?.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            activeSlide?.querySelector('.js-vimeo')?.contentWindow?.postMessage('{"method":"play"}', '*');
            this.enforceButtonBackgroundLoop();
          });
        }

        move(direction) {
          const slides = this.getSlides();
          const activeIndex = Math.max(
            0,
            slides.findIndex((slide) => slide.dataset.mediaId === this.activeMediaId)
          );
          const target = slides[activeIndex + direction];
          if (!target) return;
          this.activeMediaId = target.dataset.mediaId;
          this.gallery.setActiveMedia?.(this.activeMediaId, false);
          this.updateGalleryState();
        }

        getThumbnailStackStartIndex() {
          const viewportWidth = window.innerWidth;
          if (viewportWidth < 380) return 3;
          return 4;
        }

        updateThumbnails(activeIndex) {
          const thumbnails = this.getThumbnails();
          this.resetThumbnails();
          const stackStartIndex = this.getThumbnailStackStartIndex();
          if (thumbnails.length <= stackStartIndex) {
            if (this.thumbnailEndLines) this.thumbnailEndLines.hidden = true;
            return;
          }
          if (this.thumbnailEndLines) this.thumbnailEndLines.hidden = false;
          const representativeIndex = activeIndex >= stackStartIndex ? activeIndex : stackStartIndex;
          thumbnails.forEach((thumbnail, index) => {
            if (index >= stackStartIndex && index !== representativeIndex) thumbnail.hidden = true;
          });
          const representative = thumbnails[representativeIndex];
          const remaining =
            activeIndex >= stackStartIndex ? thumbnails.length - activeIndex - 1 : thumbnails.length - stackStartIndex;
          if (!representative) {
            if (this.overflowCount) this.overflowCount.hidden = true;
            return;
          }
          if (this.overflowCount) {
            representative.appendChild(this.overflowCount);
            this.overflowCount.textContent = `+${remaining}`;
            this.overflowCount.hidden = remaining <= 0;
          }
        }

        resetThumbnails() {
          this.getAllThumbnails().forEach((thumbnail) => {
            thumbnail.hidden = false;
          });
          if (this.overflowCount) this.overflowCount.hidden = true;
        }

        setupModal() {
          this.modal = document.getElementById(`MondoVideoModal-${this.dataset.sectionId}`);
          if (!this.modal) return;
          ['play', 'pause', 'ended'].forEach((eventName) =>
            this.modal.addEventListener(eventName, () => this.updateModalUI(), true)
          );
          this.handleModalTouchStart = (event) => this.startModalSwipe(event);
          this.handleModalTouchMove = (event) => this.moveModalSwipe(event);
          this.handleModalTouchEnd = () => this.endModalSwipe();
          this.handleModalWheel = (event) => {
            if (this.modal.hasAttribute('open') && Math.abs(event.deltaY) > 12) this.closeModalBySwipe(event.deltaY);
          };
          this.handleModalScroll = () => {
            if (!this.modal.hasAttribute('open')) return;
            const scrollDistance = window.scrollY - this.modalOpenScrollY;
            if (Math.abs(scrollDistance) > 8) this.closeModalBySwipe(scrollDistance);
          };
          document.addEventListener('touchstart', this.handleModalTouchStart, { passive: true, capture: true });
          document.addEventListener('touchmove', this.handleModalTouchMove, { passive: false, capture: true });
          document.addEventListener('touchend', this.handleModalTouchEnd, { capture: true });
          document.addEventListener('touchcancel', this.handleModalTouchEnd, { capture: true });
          document.addEventListener('wheel', this.handleModalWheel, { passive: true, capture: true });
          window.addEventListener('scroll', this.handleModalScroll, { passive: true });
          this.modalObserver = new MutationObserver(() => {
            if (this.modal.hasAttribute('open')) {
              this.modalOpenScrollY = window.scrollY;
              this.activateModalMedia();
              this.updateModalUI();
            } else {
              this.resetModalMedia();
            }
          });
          this.modalObserver.observe(this.modal, { attributes: true, attributeFilter: ['open'] });
          this.updateModalUI();
        }

        getActiveSource() {
          if (!this.modal) return null;
          return this.modal.querySelector('[data-mondo-video-source]');
        }

        getActiveKind() {
          const source = this.getActiveSource();
          if (!source) return 'empty';
          return this.breakpoint.matches ? source.dataset.desktopSourceKind : source.dataset.mobileSourceKind;
        }

        getActiveVideo() {
          return this.getActiveSource()?.querySelector('video') || null;
        }

        activateModalMedia() {
          if (this.getActiveKind() === 'empty') return;
          this.getActiveSource()?.querySelector('yg-video')?.playVideo?.();
        }

        startModalSwipe(event) {
          if (!this.modal.hasAttribute('open') || event.touches.length !== 1) return;
          this.swipeStartY = event.touches[0].clientY;
          this.swipeOffset = 0;
          this.modal.classList.add('is-swiping');
        }

        moveModalSwipe(event) {
          if (!this.modal.classList.contains('is-swiping') || event.touches.length !== 1) return;
          this.swipeOffset = event.touches[0].clientY - this.swipeStartY;
          if (Math.abs(this.swipeOffset) < 8) return;
          event.preventDefault();
          this.modal.style.setProperty('--mondo-swipe-offset', `${this.swipeOffset}px`);
        }

        endModalSwipe() {
          if (!this.modal.classList.contains('is-swiping')) return;
          this.modal.classList.remove('is-swiping');
          if (Math.abs(this.swipeOffset) >= 48) {
            this.closeModalBySwipe(this.swipeOffset);
            return;
          }
          this.modal.style.removeProperty('--mondo-swipe-offset');
        }

        closeModalBySwipe(direction) {
          if (!this.modal.hasAttribute('open') || this.modal.classList.contains('is-swipe-closing')) return;
          this.modal.classList.remove('is-swiping');
          this.modal.classList.add('is-swipe-closing');
          const closeOffset = direction < 0 ? '-100vh' : '100vh';
          this.modal.style.setProperty('--mondo-swipe-close-offset', closeOffset);
          window.setTimeout(() => {
            this.modal.hide?.();
            this.modal.classList.remove('is-swipe-closing');
            this.swipeOffset = 0;
            this.modal.style.removeProperty('--mondo-swipe-offset');
            this.modal.style.removeProperty('--mondo-swipe-close-offset');
          }, 180);
        }

        resetModalMedia() {
          if (!this.modal) return;
          this.modal.querySelectorAll('yg-video').forEach((video) => video.pauseVideo?.());
          this.modal.querySelectorAll('video').forEach((video) => {
            video.pause();
            try {
              video.currentTime = 0;
            } catch (error) {
              return;
            }
          });
          this.modal.querySelectorAll('iframe').forEach((iframe) => {
            if (iframe.src) iframe.src = iframe.src;
          });
          this.updateModalUI();
        }

        updateModalUI() {
          if (!this.modal) return;
          const kind = this.getActiveKind();
          const video = this.getActiveVideo();
          const playing = Boolean(video && !video.paused && !video.ended);
          this.modal.dataset.activeKind = kind;
          this.modal.dataset.playing = String(playing);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customElements.get('product-sticky-add-to-cart')) return;

    class ProductStickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.mainProduct = this.closest('product-info');
        this.infoWrapper = this.closest('.product__info-wrapper');
        this.mainMount = document.getElementById('MainContent') || document.querySelector('main');
        this.productBoundary = this.mainProduct?.querySelector('.product');
        this.originalButton = this.mainProduct?.querySelector(`#ProductSubmitButton-${this.sectionId}`);
        this.originalProductForm = this.originalButton?.closest('product-form');
        this.productFormErrorWrapper = this.originalProductForm?.querySelector('.product-form__error-message-wrapper');
        this.inner = this.querySelector('.product-sticky-add-to-cart__inner');
        this.toggleButton = this.querySelector('[data-sticky-atc-toggle]');
        this.summary = this.querySelector('[data-sticky-atc-summary]');
        this.arrow = this.querySelector('[data-sticky-atc-arrow]');
        this.submitButton = this.querySelector('.product-sticky-add-to-cart__submit');
        this.submitButtonLabel = this.submitButton?.querySelector('[data-sticky-atc-label]');
        this.loadingSpinner = this.submitButton?.querySelector('.loading__spinner');
        this.errorToast = this.querySelector('[data-add-to-cart-error-toast]');
        this.errorToastMessage = this.errorToast?.querySelector('[data-add-to-cart-error-message]');
        this.errorToastCloseButton = this.errorToast?.querySelector('[data-add-to-cart-error-close]');
        this.price = this.querySelector('[data-sticky-atc-price]');
        this.mobileMedia = window.matchMedia('(max-width: 999px)');
        this.originalButtonAboveViewportBottom = false;
        this.productVisible = false;
        this.originalButtonReady = false;
        this.productBoundaryReady = !this.mobileMedia.matches;
        this.mobileScrollThreshold = 100;
        this.mobileScrollReady = !this.mobileMedia.matches || window.scrollY >= this.mobileScrollThreshold;
        this.shouldHide = true;
        this.visualRoot = this;
        this.canExpand = false;
        this.visibilityVersion = 0;
        this.visibilityTimer = null;

        if (!this.originalButton || !this.inner || !this.toggleButton || !this.summary || !this.submitButton) return;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSubmitKeydown = this.handleSubmitKeydown.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
        this.handleKitVariantChange = this.handleKitVariantChange.bind(this);
        this.handleAddonsChange = this.handleAddonsChange.bind(this);
        this.handleProductFormError = this.handleProductFormError.bind(this);
        this.handleProductFormSuccess = this.handleProductFormSuccess.bind(this);
        this.syncProductFormError = this.syncProductFormError.bind(this);
        this.hideErrorToast = this.hideErrorToast.bind(this);

        this.toggleButton.addEventListener('click', this.handleToggle);
        this.submitButton.addEventListener('click', this.handleSubmit);
        this.submitButton.addEventListener('keydown', this.handleSubmitKeydown);
        this.errorToastCloseButton?.addEventListener('click', this.hideErrorToast);
        this.submitButton.setAttribute('role', 'button');
        this.mobileMedia.addEventListener('change', this.handleMediaChange);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        document.addEventListener('yg:variant-change', this.handleKitVariantChange);
        document.addEventListener('yg:addons-change', this.handleAddonsChange);
        document.addEventListener('product-form:error', this.handleProductFormError);
        document.addEventListener('product-form:success', this.handleProductFormSuccess);

        this.originalButtonObserver = new IntersectionObserver(([entry]) => {
          const viewportBottom = entry.rootBounds?.bottom ?? window.innerHeight;
          this.originalButtonAboveViewportBottom = entry.boundingClientRect.top <= viewportBottom;
          this.originalButtonReady = true;
          this.updateVisibility();
        });
        this.originalButtonObserver.observe(this.originalButton);

        if (this.productBoundary) {
          this.productBoundaryObserver = new IntersectionObserver(([entry]) => {
            this.productVisible = entry.isIntersecting && entry.intersectionRatio > 0;
            this.productBoundaryReady = true;
            this.updateVisibility();
          });
          this.productBoundaryObserver.observe(this.productBoundary);
        } else {
          this.productBoundaryReady = true;
        }

        this.buttonMutationObserver = new MutationObserver(() => this.syncButtonState());
        this.buttonMutationObserver.observe(this.originalButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          characterData: true,
          subtree: true,
        });

        if (this.productFormErrorWrapper) {
          this.productFormErrorObserver = new MutationObserver(this.syncProductFormError);
          this.productFormErrorObserver.observe(this.productFormErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            characterData: true,
            subtree: true,
          });
          this.syncProductFormError();
        }

        this.resizeObserver = new ResizeObserver(() => {
          this.updateOverflowState();
          this.updateReservedSpace();
        });
        this.resizeObserver.observe(this.summary);
        this.resizeObserver.observe(this);

        this.summaryMutationObserver = new MutationObserver(() => {
          window.requestAnimationFrame(() => this.updateOverflowState());
        });
        this.summaryMutationObserver.observe(this.summary, {
          childList: true,
          characterData: true,
          subtree: true,
        });

        this.updatePortalPlacement();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange);
        }

        this.syncButtonState();
        window.requestAnimationFrame(() => {
          this.updateOverflowState();
          this.updateReservedSpace();
        });
        document.fonts?.ready.then(() => {
          this.updateOverflowState();
          this.updateReservedSpace();
        });
      }

      disconnectedCallback() {
        this.toggleButton?.removeEventListener('click', this.handleToggle);
        this.submitButton?.removeEventListener('click', this.handleSubmit);
        this.submitButton?.removeEventListener('keydown', this.handleSubmitKeydown);
        this.errorToastCloseButton?.removeEventListener('click', this.hideErrorToast);
        this.mobileMedia?.removeEventListener('change', this.handleMediaChange);
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('yg:variant-change', this.handleKitVariantChange);
        document.removeEventListener('yg:addons-change', this.handleAddonsChange);
        document.removeEventListener('product-form:error', this.handleProductFormError);
        document.removeEventListener('product-form:success', this.handleProductFormSuccess);
        this.originalButtonObserver?.disconnect();
        this.productBoundaryObserver?.disconnect();
        this.buttonMutationObserver?.disconnect();
        this.productFormErrorObserver?.disconnect();
        this.summaryMutationObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.variantChangeUnsubscriber?.();
        window.clearTimeout(this.visibilityTimer);
        this.infoWrapper?.style.removeProperty('--product-sticky-atc-reserved-height');
        this.mobilePortal?.remove();
      }

      handleToggle() {
        if (!this.canExpand) return;

        const expanded = !this.visualRoot.classList.contains('is-expanded');
        this.visualRoot.classList.toggle('is-expanded', expanded);
        this.toggleButton.setAttribute('aria-expanded', String(expanded));
        window.requestAnimationFrame(() => this.updateReservedSpace());
      }

      handleSubmit(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || !this.originalButton) return;
        this.addToCartPending = true;
        this.hideErrorToast();
        this.originalButton.click();
      }

      handleProductFormError(event) {
        if (event.target !== this.originalProductForm) return;
        this.addToCartPending = false;
        this.showErrorToast(event.detail?.message || this.getProductFormErrorMessage());
      }

      handleProductFormSuccess(event) {
        if (event.target !== this.originalProductForm) return;
        this.addToCartPending = false;
        this.hideErrorToast();
      }

      getProductFormErrorMessage() {
        if (!this.productFormErrorWrapper || this.productFormErrorWrapper.hidden) return '';
        return this.productFormErrorWrapper.querySelector('.product-form__error-message')?.textContent?.trim() || '';
      }

      syncProductFormError() {
        const message = this.getProductFormErrorMessage();
        if (message) {
          this.addToCartPending = false;
          this.showErrorToast(message);
        } else {
          this.hideErrorToast();
        }
      }

      showErrorToast(message) {
        if (!message || !this.errorToast || !this.errorToastMessage) return;
        const barTop = this.visualRoot?.getBoundingClientRect().top;
        const contentTop = this.inner?.getBoundingClientRect().top;
        const barOffset = Math.max(0, (contentTop ?? 0) - (barTop ?? 0));
        this.errorToast.style.setProperty('--yg-add-to-cart-toast-bar-offset', `${barOffset}px`);
        this.errorToastMessage.textContent = message;
        this.errorToast.hidden = false;
      }

      hideErrorToast() {
        if (this.errorToast) this.errorToast.hidden = true;
      }

      handleSubmitKeydown(event) {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        this.handleSubmit(event);
      }

      handleMediaChange() {
        if (!this.mobileMedia.matches) this.productBoundaryReady = true;
        this.mobileScrollReady = !this.mobileMedia.matches || window.scrollY >= this.mobileScrollThreshold;
        this.updatePortalPlacement();
        this.updateVisibility();
        this.updateOverflowState();
        this.updateReservedSpace();
      }

      handleScroll() {
        if (!this.mobileMedia.matches) return;

        const mobileScrollReady = window.scrollY >= this.mobileScrollThreshold;
        if (mobileScrollReady === this.mobileScrollReady) return;

        this.mobileScrollReady = mobileScrollReady;
        this.updateVisibility();
      }

      updatePortalPlacement() {
        const shouldUsePortal = this.mobileMedia.matches && this.mainMount;
        const wasExpanded = this.visualRoot?.classList.contains('is-expanded') ?? false;

        if (shouldUsePortal) {
          if (!this.mobilePortal) {
            this.mobilePortal = document.createElement('div');
            this.mobilePortal.className = 'product-sticky-add-to-cart product-sticky-add-to-cart--mobile-portal';
            this.mobilePortal.dataset.sectionId = this.sectionId;
            this.mainMount.append(this.mobilePortal);
          }

          if (this.inner.parentElement !== this.mobilePortal) this.mobilePortal.append(this.inner);
          this.visualRoot = this.mobilePortal;
          this.resizeObserver?.observe(this.mobilePortal);
          this.hidden = true;
        } else {
          if (this.inner.parentElement !== this) this.append(this.inner);
          if (this.mobilePortal) this.resizeObserver?.unobserve(this.mobilePortal);
          this.mobilePortal?.remove();
          this.mobilePortal = null;
          this.visualRoot = this;
        }

        this.visualRoot.classList.toggle('is-expanded', wasExpanded);
        this.visualRoot.dataset.canExpand = String(this.canExpand);
        this.applyVisibility();
      }

      applyVisibility() {
        if (!this.visualRoot) return;

        if (this.visualRoot !== this) this.hidden = true;
        const visualRoot = this.visualRoot;
        const shouldPreserveLayout = !this.mobileMedia.matches && visualRoot === this;
        const visibilityVersion = ++this.visibilityVersion;
        window.clearTimeout(this.visibilityTimer);

        visualRoot.setAttribute('aria-hidden', String(this.shouldHide));
        visualRoot.inert = this.shouldHide;

        if (this.shouldHide) {
          visualRoot.classList.add('is-hidden');
          if (shouldPreserveLayout) {
            visualRoot.hidden = false;
            return;
          }
          if (visualRoot.hidden) return;

          this.visibilityTimer = window.setTimeout(() => {
            if (visibilityVersion === this.visibilityVersion && this.shouldHide && visualRoot === this.visualRoot) {
              visualRoot.hidden = true;
            }
          }, 250);
          return;
        }

        const wasHidden = visualRoot.hidden;
        visualRoot.classList.add('is-hidden');
        visualRoot.hidden = false;

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            if (visibilityVersion !== this.visibilityVersion || this.shouldHide || visualRoot !== this.visualRoot) return;

            visualRoot.classList.remove('is-hidden');
            if (wasHidden) {
              this.updateOverflowState();
              this.updateReservedSpace();
            }
          });
        });
      }

      handleVariantChange(event) {
        if (String(event?.data?.sectionId) !== String(this.sectionId)) return;

        const variantId = event.data.variant?.id;
        this.dataset.currentVariantId = String(variantId);
        const priceTemplate = this.querySelector(`[data-sticky-atc-variant-price="${variantId}"]`);

        if (priceTemplate?.content && this.price) {
          this.renderCombinedPrice(variantId);
        } else {
          const source = event.data.html.querySelector(
            `product-sticky-add-to-cart[data-section-id="${this.sectionId}"]`
          );
          const sourcePrice = source?.querySelector('[data-sticky-atc-price]');

          if (sourcePrice && this.price) {
            this.price.innerHTML = sourcePrice.innerHTML;
            this.renderCombinedPrice(variantId);
          }
        }

        this.syncButtonState();
        window.requestAnimationFrame(() => {
          this.updateOverflowState();
          this.updateReservedSpace();
        });
      }

      handleKitVariantChange(event) {
        if (String(event.detail?.sectionId) !== String(this.sectionId)) return;

        const priceTemplate = this.querySelector(
          `[data-sticky-atc-variant-price="${event.detail?.variantId}"]`
        );
        if (!priceTemplate?.content || !this.price) return;

        this.dataset.currentVariantId = String(event.detail.variantId);
        this.renderCombinedPrice(event.detail.variantId);
      }

      handleAddonsChange() {
        this.renderCombinedPrice(this.dataset.currentVariantId);
      }

      renderCombinedPrice(variantId) {
        const priceTemplate = this.querySelector(`[data-sticky-atc-variant-price="${variantId}"]`);
        if (!priceTemplate?.content || !this.price) return;

        this.price.replaceChildren(priceTemplate.content.cloneNode(true));
        const addonTotal = Array.from(
          this.mainProduct?.querySelectorAll('.product-addons__list [data-product-addon-item]') || []
        ).reduce((total, item) => {
          const price = Number.parseInt(item.dataset.price, 10) || 0;
          const quantity = Number.parseInt(item.dataset.quantity, 10) || 0;
          return total + price * quantity;
        }, 0);
        const price = Number.parseInt(priceTemplate.dataset.price, 10) || 0;
        const comparePrice = Number.parseInt(priceTemplate.dataset.comparePrice, 10) || 0;
        const priceElement = this.price.querySelector('.product-sticky-add-to-cart__current-price');
        const comparePriceElement = this.price.querySelector('.product-sticky-add-to-cart__compare-price');

        if (priceElement) priceElement.textContent = this.formatMoney(price + addonTotal);
        if (comparePriceElement && comparePrice > price) {
          comparePriceElement.textContent = this.formatMoney(comparePrice + addonTotal);
        }
      }

      formatMoney(cents) {
        const defaultToken = '$' + '{' + '{' + 'amount' + '}' + '}';
        const placeholderToken = '{' + '{' + 'amount' + '}' + '}';
        const format = this.dataset.moneyFormat || defaultToken;
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const placeholder = match?.[1] || 'amount';
        const formats = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
        };
        const [precision, thousands, decimal] = formats[placeholder] || formats.amount;
        const effectivePrecision = Number(cents) % 100 === 0 ? 0 : precision;
        const value = (Number(cents) / 100).toFixed(effectivePrecision);
        const parts = value.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const formatted = effectivePrecision > 0 ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
        return format.replace(match?.[0] || placeholderToken, formatted);
      }

      syncButtonState() {
        if (!this.originalButton || !this.submitButton) return;

        const disabled =
          this.originalButton.disabled ||
          this.originalButton.getAttribute('aria-disabled') === 'true';
        const loading = this.originalButton.classList.contains('loading');
        const originalLabel = this.originalButton.querySelector(':scope > span')?.textContent?.trim();

        this.submitButton.classList.toggle('disabled', disabled);
        this.submitButton.classList.toggle('loading', loading);
        this.submitButton.setAttribute('aria-disabled', String(disabled));
        this.submitButton.tabIndex = disabled ? -1 : 0;

        if (originalLabel && this.submitButtonLabel) {
          this.submitButtonLabel.textContent = originalLabel;
          this.submitButton.setAttribute('aria-label', originalLabel);
        }

        this.loadingSpinner?.classList.toggle('hidden', !loading);
      }

      updateOverflowState() {
        if (!this.summary || !this.arrow || !this.toggleButton) return;
        if (!this.summary.isConnected || this.summary.clientWidth <= 0) return;

        const previousWhiteSpace = this.summary.style.whiteSpace;
        this.summary.style.whiteSpace = 'nowrap';
        const availableWidth = this.summary.clientWidth;
        const contentRange = document.createRange();
        contentRange.selectNodeContents(this.summary);
        const singleLineWidth = Math.max(this.summary.scrollWidth, contentRange.getBoundingClientRect().width);
        contentRange.detach();
        const canExpand = singleLineWidth > availableWidth + 1;
        this.summary.style.whiteSpace = previousWhiteSpace;

        this.canExpand = canExpand;
        this.visualRoot.dataset.canExpand = String(canExpand);
        this.arrow.hidden = !canExpand;
        this.toggleButton.disabled = !canExpand;

        if (!canExpand) {
          this.visualRoot.classList.remove('is-expanded');
          this.toggleButton.setAttribute('aria-expanded', 'false');
        }
      }

      updateVisibility() {
        if (!this.originalButtonReady) return;
        if (this.mobileMedia.matches && !this.productBoundaryReady) return;

        const productAllowsDisplay = !this.mobileMedia.matches || (this.productVisible && this.mobileScrollReady);
        this.shouldHide = this.originalButtonAboveViewportBottom || !productAllowsDisplay;
        this.applyVisibility();
        window.requestAnimationFrame(() => this.updateReservedSpace());
      }

      updateReservedSpace() {
        if (!this.infoWrapper) return;

        if (this.mobileMedia.matches) {
          this.infoWrapper.style.setProperty('--product-sticky-atc-reserved-height', '0px');
          return;
        }

        const height = Math.ceil(this.getBoundingClientRect().height);
        this.infoWrapper.style.setProperty('--product-sticky-atc-reserved-height', `${height}px`);
      }
    }

    window.customElements.define('product-sticky-add-to-cart', ProductStickyAddToCart);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-variant-kit-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-variant-kit-picker')) {
    customElements.define(
      'yg-variant-kit-picker',
      class YGVariantKitPicker extends HTMLElement {
        connectedCallback() {
          if (this.isInitialized) return;
          this.isInitialized = true;
          this.productInfo = this.closest('product-info');
          this.productFormElement = this.productInfo?.querySelector('product-form');
          this.form = document.getElementById(this.dataset.productFormId);
          this.cart =
            document.querySelector('cart-notification') ||
            document.querySelector('cart-drawer') ||
            document.querySelector('beni-cart-popover');
          this.boundClickHandler = this.handleClick.bind(this);
          this.boundSubmitHandler = this.handleSubmit.bind(this);
          this.boundCartUpdateHandler = this.handleCartUpdate.bind(this);
          this.addEventListener('click', this.boundClickHandler);
          this.productFormElement?.addEventListener('submit', this.boundSubmitHandler, true);
          if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.boundCartUpdateHandler);
          }
          this.syncGiftAvailability();
          this.startGiftAvailabilityMonitor();
          window.requestAnimationFrame(() => this.ensureInitialVariant());
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.boundClickHandler);
          this.productFormElement?.removeEventListener('submit', this.boundSubmitHandler, true);
          this.cartUpdateUnsubscriber?.();
          this.cartUpdateUnsubscriber = undefined;
          this.stopGiftAvailabilityMonitor();
          this.giftAvailabilityRequestId = (this.giftAvailabilityRequestId || 0) + 1;
          this.isInitialized = false;
        }

        get variantSelects() {
          return this.querySelector('variant-selects');
        }

        get activeCard() {
          return this.querySelector('[data-variant-card].is-active');
        }

        handleClick(event) {
          const suitTrigger = event.target.closest('[data-variant-suit-open]');
          const card = event.target.closest('[data-variant-card]');
          if (!card || !this.contains(card)) return;
          if (suitTrigger) {
            this.selectCard(card);
            this.querySelector('yg-variant-suit')?.openDrawer(card.dataset.variantId, suitTrigger);
            return;
          }
          this.selectCard(card);
        }

        selectCard(card) {
          if (!card || !this.contains(card)) return false;
          const selectedVariantId = this.form?.querySelector('[name="id"]')?.value;
          if (card.classList.contains('is-active') && String(selectedVariantId) === card.dataset.variantId)
            return false;
          this.setActiveCard(card);
          this.syncVariantInputs(card.dataset.variantId);
          this.dispatchVariantChange(card);
          this.selectVariantOptions(card, true);
          return true;
        }

        selectVariantById(variantId) {
          const card = this.querySelector(`[data-variant-card][data-variant-id="${CSS.escape(String(variantId))}"]`);
          if (!card) return false;
          this.selectCard(card);
          return true;
        }

        dispatchVariantChange(card) {
          this.dispatchEvent(
            new CustomEvent('yg:variant-change', {
              bubbles: true,
              detail: {
                sectionId: this.dataset.sectionId,
                variantId: Number.parseInt(card.dataset.variantId, 10),
              },
            })
          );
        }

        setActiveCard(activeCard) {
          this.querySelectorAll('[data-variant-card]').forEach((card) => {
            const isActive = card === activeCard;
            card.classList.toggle('is-active', isActive);
            card.querySelector('[data-variant-card-select]')?.setAttribute('aria-checked', String(isActive));
            card.querySelector('[data-variant-card-panel]')?.setAttribute('aria-hidden', String(!isActive));
          });
        }

        selectVariantOptions(card, dispatchChange) {
          let optionValues = [];
          try {
            optionValues = JSON.parse(card.dataset.optionValues || '[]');
          } catch {}

          const inputs = Array.from(
            this.variantSelects?.querySelectorAll('.yg-variant-kit-picker__native-options fieldset') || []
          )
            .map((fieldset, index) =>
              Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
                (input) => input.value === String(optionValues[index] ?? '')
              )
            )
            .filter(Boolean);

          inputs.forEach((input) => {
            input.checked = true;
          });
          if (dispatchChange && inputs.length) {
            const changeInput = inputs[inputs.length - 1];
            changeInput.dataset.variantId = card.dataset.variantId;
            changeInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        syncVariantInputs(variantId) {
          if (!variantId) return;
          const formSelectors = [
            `#product-form-${this.dataset.sectionId}`,
            `#product-form-installment-${this.dataset.sectionId}`,
            `#yg-product-form-installment-${this.dataset.sectionId}`,
          ].join(', ');

          this.productInfo?.querySelectorAll(formSelectors).forEach((form) => {
            const input = form.querySelector('input[name="id"]');
            if (!input) return;
            input.disabled = false;
            input.value = variantId;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        ensureInitialVariant() {
          const card = this.activeCard;
          if (!card || !this.form) return;
          const activeVariantId = Number.parseInt(card.dataset.variantId, 10);
          const formVariantId = Number.parseInt(this.form.querySelector('[name="id"]')?.value, 10);
          if (activeVariantId && activeVariantId !== formVariantId) {
            this.syncVariantInputs(activeVariantId);
            this.selectVariantOptions(card, true);
          }
        }

        getGiftLines() {
          const quantities = new Map();
          this.activeCard?.querySelectorAll('[data-gift-line]').forEach((gift) => {
            const id = Number.parseInt(gift.dataset.giftVariantId, 10);
            const quantity = Number.parseInt(gift.dataset.giftQuantity, 10);
            if (!id || quantity <= 0 || !this.isGiftAvailable(gift)) return;
            quantities.set(id, (quantities.get(id) || 0) + quantity);
          });
          const sourceLabel = (this.dataset.giftSourceLabel || '').trim();
          const sourceTitle = this.activeCard?.dataset.variantTitle || '';
          return Array.from(quantities, ([id, quantity]) => {
            const properties = {
              _yg_free_gift: 'true',
              _yg_parent_variant: this.activeCard?.dataset.variantId || '',
            };
            // Customer-visible source hint (no leading "_" so it shows in cart/checkout).
            if (sourceLabel && sourceTitle) properties[sourceLabel] = sourceTitle;
            return { id, quantity, properties };
          });
        }

        isGiftAvailable(gift) {
          if (gift.dataset.giftInventoryTracked !== 'true') return true;
          const quantity = Number.parseInt(gift.dataset.giftQuantity, 10) || 0;
          const remainingQuantity = Number.parseInt(gift.dataset.giftRemainingQuantity, 10) || 0;
          return quantity > 0 && remainingQuantity >= quantity;
        }

        syncGiftAvailability() {
          this.querySelectorAll('[data-gift-line]').forEach((gift) => {
            gift.hidden = !this.isGiftAvailable(gift);
          });
          this.querySelectorAll('[data-gift-list]').forEach((giftList) => {
            giftList.hidden = !Array.from(giftList.querySelectorAll('[data-gift-line]')).some((gift) => !gift.hidden);
          });
        }

        handleCartUpdate() {
          return this.refreshGiftAvailabilityFromCart();
        }

        startGiftAvailabilityMonitor() {
          this.refreshGiftAvailabilityFromCart();
          this.giftAvailabilityInterval = window.setInterval(() => {
            if (document.visibilityState === 'visible') this.refreshGiftAvailabilityFromCart();
          }, 2000);
          this.boundGiftVisibilityHandler = () => {
            if (document.visibilityState === 'visible') this.refreshGiftAvailabilityFromCart();
          };
          document.addEventListener('visibilitychange', this.boundGiftVisibilityHandler);
        }

        stopGiftAvailabilityMonitor() {
          if (this.giftAvailabilityInterval) window.clearInterval(this.giftAvailabilityInterval);
          this.giftAvailabilityInterval = undefined;
          if (this.boundGiftVisibilityHandler) {
            document.removeEventListener('visibilitychange', this.boundGiftVisibilityHandler);
          }
          this.boundGiftVisibilityHandler = undefined;
        }

        async refreshGiftAvailabilityFromCart() {
          const trackedGifts = this.querySelectorAll('[data-gift-line][data-gift-inventory-tracked="true"]');
          if (!trackedGifts.length) return;

          const requestId = (this.giftAvailabilityRequestId || 0) + 1;
          this.giftAvailabilityRequestId = requestId;

          try {
            const cartUrl = window.routes?.cart_url || '/cart';
            const response = await fetch(`${cartUrl}.js`, {
              headers: { Accept: 'application/json' },
            });
            if (!response.ok) return;

            const cartData = await response.json();
            if (requestId !== this.giftAvailabilityRequestId || !this.isConnected) return;

            const cartQuantities = new Map();
            (cartData.items || []).forEach((item) => {
              const variantId = Number.parseInt(item.variant_id, 10);
              const quantity = Number.parseInt(item.quantity, 10) || 0;
              if (!variantId || quantity <= 0) return;
              cartQuantities.set(variantId, (cartQuantities.get(variantId) || 0) + quantity);
            });

            const cartQuantitySignature = Array.from(
              new Set(Array.from(trackedGifts, (gift) => Number.parseInt(gift.dataset.giftVariantId, 10)))
            )
              .filter(Boolean)
              .sort((firstVariantId, secondVariantId) => firstVariantId - secondVariantId)
              .map((variantId) => `${variantId}:${cartQuantities.get(variantId) || 0}`)
              .join('|');
            if (cartQuantitySignature === this.giftCartQuantitySignature) return;
            this.giftCartQuantitySignature = cartQuantitySignature;

            trackedGifts.forEach((gift) => {
              const variantId = Number.parseInt(gift.dataset.giftVariantId, 10);
              const inventoryQuantity = Number.parseInt(gift.dataset.giftInventoryQuantity, 10) || 0;
              const cartQuantity = cartQuantities.get(variantId) || 0;
              gift.dataset.giftRemainingQuantity = String(Math.max(inventoryQuantity - cartQuantity, 0));
            });
            this.syncGiftAvailability();
          } catch {}
        }

        decrementGiftInventory(giftLines) {
          const addedQuantities = new Map(giftLines.map((line) => [line.id, line.quantity]));
          this.querySelectorAll('[data-gift-line][data-gift-inventory-tracked="true"]').forEach((gift) => {
            const variantId = Number.parseInt(gift.dataset.giftVariantId, 10);
            const addedQuantity = addedQuantities.get(variantId) || 0;
            if (!addedQuantity) return;
            const remainingQuantity = Number.parseInt(gift.dataset.giftRemainingQuantity, 10) || 0;
            gift.dataset.giftRemainingQuantity = String(Math.max(remainingQuantity - addedQuantity, 0));
          });
          this.syncGiftAvailability();
        }

        getAddonLines() {
          const quantities = new Map();
          this.productInfo?.querySelectorAll('[data-product-addon-item]').forEach((item) => {
            const id = Number.parseInt(item.dataset.variantId, 10);
            const quantity = Number.parseInt(item.dataset.quantity, 10) || 0;
            if (!id || quantity <= 0) return;
            quantities.set(id, (quantities.get(id) || 0) + quantity);
          });
          return Array.from(quantities, ([id, quantity]) => ({ id, quantity }));
        }

        getMainProductLine(formData) {
          const variantId = Number.parseInt(this.activeCard?.dataset.variantId || formData.get('id'), 10);
          if (!variantId) return null;
          const line = { id: variantId, quantity: 1 };
          const sellingPlan = formData.get('selling_plan');
          const properties = {};
          if (sellingPlan) line.selling_plan = Number.parseInt(sellingPlan, 10) || sellingPlan;
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)]$/);
            if (match && value !== '') properties[match[1]] = value;
          });
          if (Object.keys(properties).length) line.properties = properties;
          return line;
        }

        async handleSubmit(event) {
          if (event.target !== this.form) return;
          const giftLines = this.getGiftLines();
          const addonLines = this.getAddonLines();
          if (!giftLines.length && !addonLines.length) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.isSubmitting) return;

          const mainProductLine = this.getMainProductLine(new FormData(this.form));
          if (!mainProductLine) return;

          this.isSubmitting = true;
          this.setLoading(true);
          this.productFormElement?.handleErrorMessage?.();
          const payload = { items: [mainProductLine, ...addonLines, ...giftLines] };

          if (this.cart) {
            payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
            payload.sections_url = window.location.pathname;
            this.cart.setActiveElement(document.activeElement);
          }

          try {
            const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify(payload),
            });
            let responseData;
            if (response.status === 429) {
              responseData = { status: 429 };
            } else if ((response.headers.get('content-type') || '').includes('application/json')) {
              responseData = await response.json();
            } else if (!response.ok) {
              responseData = {
                status: response.status,
                message: response.statusText || 'Unable to add items to cart.',
              };
            } else {
              responseData = await response.json();
            }

            if (!response.ok || responseData.status) {
              const errorMessage =
                response.status === 429 || Number(responseData.status) === 429
                  ? "You're adding items too quickly. Please wait a moment and try again."
                  : responseData.errors ||
                    responseData.description ||
                    responseData.message ||
                    'Unable to add items to cart.';

              throw Object.assign(new Error(errorMessage), { responseData, status: response.status });
            }

            this.decrementGiftInventory(giftLines);

            if (!this.cart) {
              window.location = window.routes?.cart_url || '/cart';
              return;
            }

            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              await publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainProductLine.id,
                cartData: responseData,
              });
            }
            this.cart.renderContents(responseData);
          } catch (error) {
            const message =
              error.status === 429 || Number(error.responseData?.status) === 429
                ? "You're adding items too quickly. Please wait a moment and try again."
                : error.responseData?.errors ||
                  error.responseData?.description ||
                  error.responseData?.message ||
                  error.message;
            this.productFormElement?.handleErrorMessage?.(message);
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainProductLine.id,
                errors: message,
                message,
              });
            }
            if (window.StandardEvents?.CartErrorEvent && this.productFormElement) {
              this.productFormElement.dispatchEvent(
                new window.StandardEvents.CartErrorEvent({ error: message, code: 'INVALID' })
              );
            }
          } finally {
            this.isSubmitting = false;
            this.setLoading(false);
          }
        }

        setLoading(loading) {
          const submitButton = this.productFormElement?.querySelector('[type="submit"]');
          const spinner = this.productFormElement?.querySelector('.loading__spinner');
          if (!submitButton) return;
          if (loading) submitButton.setAttribute('aria-disabled', 'true');
          else submitButton.removeAttribute('aria-disabled');
          submitButton.classList.toggle('loading', loading);
          spinner?.classList.toggle('hidden', !loading);
          if (!loading && this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-variant-kit-popup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-variant-kit-comparison')) {
    class YGVariantKitComparison extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.variants = this.readVariants();
        this.activeVariantId = String(this.dataset.activeVariantId || this.variants[0]?.id || '');
        this.selectedIds = this.initialSelectedIds();
        this.openDropdown = null;
        this.dropdownMotion = null;
        this.dropdownMotionTimer = null;
        this.picker = document.getElementById(this.dataset.pickerId);
        this.modal = this.closest('modal-dialog');
        this.scrollContainer = this.querySelector('.yg-kit-comparison__scroll');
        this.cardsContainer = this.querySelector('[data-kit-comparison-cards]');
        this.tableHead = this.querySelector('[data-kit-comparison-head]');
        this.handleClickBound = this.handleClick.bind(this);
        this.handleDocumentPointerDownBound = this.handleDocumentPointerDown.bind(this);
        this.handleKeydownBound = this.handleKeydown.bind(this);
        this.handleVariantChangeBound = this.handleVariantChange.bind(this);
        this.handleViewportChangeBound = this.handleViewportChange.bind(this);
        this.handleComparisonScrollBound = this.updateTableHeadVisibility.bind(this);
        this.addEventListener('click', this.handleClickBound);
        document.addEventListener('pointerdown', this.handleDocumentPointerDownBound);
        this.addEventListener('keydown', this.handleKeydownBound);
        this.picker?.addEventListener('yg:variant-change', this.handleVariantChangeBound);
        this.mobileQuery.addEventListener('change', this.handleViewportChangeBound);
        this.scrollContainer?.addEventListener('scroll', this.handleComparisonScrollBound, { passive: true });
        this.setupModalController();
        this.reconcileSlots(this.activeCount);
        this.render();
      }

      disconnectedCallback() {
        if (!this.initialized) return;
        this.removeEventListener('click', this.handleClickBound);
        document.removeEventListener('pointerdown', this.handleDocumentPointerDownBound);
        this.removeEventListener('keydown', this.handleKeydownBound);
        this.picker?.removeEventListener('yg:variant-change', this.handleVariantChangeBound);
        this.mobileQuery?.removeEventListener('change', this.handleViewportChangeBound);
        this.scrollContainer?.removeEventListener('scroll', this.handleComparisonScrollBound);
        window.clearTimeout(this.dropdownMotionTimer);
        this.teardownModalController();
        this.initialized = false;
      }

      readVariants() {
        return Array.from(this.querySelectorAll('[data-kit-variant-record]')).map((record) => ({
          id: String(record.dataset.variantId),
          title: record.querySelector('[data-kit-variant-title]')?.textContent.trim() || '',
          price: record.querySelector('[data-kit-variant-price]')?.textContent.trim() || '',
          comparePrice: record.querySelector('[data-kit-variant-compare-price]')?.textContent.trim() || '',
          description: record.querySelector('[data-kit-variant-description]')?.textContent.trim() || '',
          image: record.querySelector('[data-kit-variant-image]')?.innerHTML.trim() || '',
          items: Array.from(record.querySelectorAll('[data-kit-item-record]')).map((item) => ({
            name: item.querySelector('[data-kit-item-name]')?.textContent.trim() || '',
            number: Number.parseInt(item.querySelector('[data-kit-item-number]')?.textContent, 10) || 0,
            image: item.querySelector('[data-kit-item-image]')?.innerHTML.trim() || '',
          })),
        }));
      }

      initialSelectedIds() {
        const active = this.variantById(this.activeVariantId) || this.variants[0];
        return [active, ...this.variants.filter((variant) => variant !== active)]
          .slice(0, 3)
          .map((variant) => variant.id);
      }
      get activeCount() {
        return Math.min(this.mobileQuery.matches ? 2 : 3, this.variants.length);
      }

      get activeVariants() {
        return this.selectedIds
          .slice(0, this.activeCount)
          .map((id) => this.variantById(id))
          .filter(Boolean);
      }

      variantById(id) {
        return this.variants.find((variant) => variant.id === String(id));
      }

      reconcileSlots(count) {
        const limit = Math.min(count, this.variants.length);
        const used = new Set();
        for (let slot = 0; slot < limit; slot += 1) {
          let id = this.selectedIds[slot];
          if (!this.variantById(id) || used.has(id)) id = this.variants.find((variant) => !used.has(variant.id))?.id;
          if (!id) continue;
          this.selectedIds[slot] = id;
          used.add(id);
        }
      }

      updateOpenDropdown(nextDropdown, animate = true, dropdownsOnly = false) {
        const previousDropdown = this.openDropdown;
        this.openDropdown = nextDropdown;
        window.clearTimeout(this.dropdownMotionTimer);
        this.dropdownMotion = animate
          ? {
              opening: nextDropdown !== previousDropdown ? nextDropdown : null,
              closing: previousDropdown !== nextDropdown ? previousDropdown : null,
            }
          : null;
        if (dropdownsOnly) this.renderDropdowns();
        else this.render();
        if (!this.dropdownMotion) return;
        this.dropdownMotionTimer = window.setTimeout(() => {
          this.dropdownMotion = null;
          this.dropdownMotionTimer = null;
        }, 250);
      }

      handleClick(event) {
        const specialist = event.target.closest('[data-kit-popup-specialist]');
        if (specialist) {
          if (typeof window.zE === 'function') {
            window.zE('messenger', 'open');
          } else {
            console.warn('Zendesk Web Widget is not available.');
          }
          return;
        }

        const trigger = event.target.closest('[data-kit-dropdown-trigger]');
        if (trigger) {
          const key = `${trigger.dataset.scope}:${trigger.dataset.slot}`;
          this.updateOpenDropdown(this.openDropdown === key ? null : key, true, true);
          return;
        }

        const option = event.target.closest('[data-kit-dropdown-option]');
        if (option && !option.disabled) {
          const slot = Number.parseInt(option.dataset.slot, 10);
          this.selectedIds[slot] = option.dataset.variantId;
          this.reconcileSlots(this.activeCount);
          this.updateOpenDropdown(null);
          return;
        }

        const choose = event.target.closest('[data-kit-choose]');
        if (choose && !choose.disabled) {
          const variantId = String(choose.dataset.variantId);
          let changed = false;
          this.isChoosingVariant = true;
          try {
            changed = this.picker?.selectVariantById(variantId);
          } finally {
            this.isChoosingVariant = false;
          }
          if (changed !== false) {
            this.activeVariantId = variantId;
            this.closeAndAddToCart();
          }
          return;
        }

        if (this.openDropdown && !event.target.closest('.yg-kit-comparison__select')) {
          this.updateOpenDropdown(null, true, true);
        }
      }

      handleDocumentPointerDown(event) {
        if (!this.openDropdown || this.contains(event.target)) return;
        this.updateOpenDropdown(null, true, true);
      }

      handleKeydown(event) {
        if (event.key !== 'Escape' || !this.openDropdown) return;
        event.stopPropagation();
        this.updateOpenDropdown(null, true, true);
      }

      handleVariantChange(event) {
        const variantId = String(event.detail?.variantId || '');
        if (!this.variantById(variantId)) return;
        this.activeVariantId = variantId;
        if (!this.selectedIds.slice(0, this.activeCount).includes(variantId)) {
          this.selectedIds[0] = variantId;
          this.reconcileSlots(this.activeCount);
        }
        if (!this.isChoosingVariant) this.render();
      }

      handleViewportChange() {
        this.reconcileSlots(this.activeCount);
        this.openDropdown = null;
        this.dropdownMotion = null;
        window.clearTimeout(this.dropdownMotionTimer);
        this.render();
        if (this.modal?.hasAttribute('open')) {
          this.clearDrawerMotion();
          this.modal.classList.remove('is-drawer-closing');
          this.modal.classList.toggle('is-drawer-visible', this.mobileQuery.matches);
        }
      }
      setupModalController() {
        if (!this.modal || this.controlledModal === this.modal) return;
        const modal = this.modal;
        this.controlledModal = modal;
        this.originalModalShow = modal.show;
        this.originalModalHide = modal.hide;
        modal.show = (opener) => {
          if (this.mobileQuery.matches) this.showMobileDrawer(opener);
          else this.showDesktopModal(opener);
        };
        modal.hide = () => {
          if (this.mobileQuery.matches) this.hideMobileDrawer();
          else this.hideDesktopModal();
        };
        this.closeButton = modal.querySelector('[id^="ModalClose-"]');
        this.handleCloseCaptureBound = (event) => {
          if (!modal.hasAttribute('open')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.mobileQuery.matches) this.hideMobileDrawer();
          else this.hideDesktopModal();
        };
        this.closeButton?.addEventListener('click', this.handleCloseCaptureBound, true);
      }

      teardownModalController() {
        const modal = this.controlledModal;
        if (!modal) return;
        this.clearDrawerMotion();
        this.closeButton?.removeEventListener('click', this.handleCloseCaptureBound, true);
        modal.show = this.originalModalShow;
        modal.hide = this.originalModalHide;
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        this.unlockPageScroll();
        this.controlledModal = null;
        this.closeButton = null;
      }

      showDesktopModal(opener) {
        const modal = this.controlledModal;
        if (!modal || modal.hasAttribute('open')) return;
        this.resetScrollPosition();
        modal.openedBy = opener;
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        this.lockPageScroll();
        modal.setAttribute('open', '');
        trapFocus(modal, modal.querySelector('[role=dialog]'));
        window.pauseAllMedia();
      }

      hideDesktopModal() {
        const modal = this.controlledModal;
        if (!modal || !modal.hasAttribute('open')) return;
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        modal.removeAttribute('open');
        this.unlockPageScroll();
        removeTrapFocus(modal.openedBy);
        window.pauseAllMedia();
        this.runPendingAddToCart();
      }

      showMobileDrawer(opener) {
        const modal = this.controlledModal;
        if (!modal || modal.hasAttribute('open')) return;
        this.clearDrawerMotion();
        const panel = modal.querySelector('.product-popup-modal__content');
        if (!panel) return;
        this.resetScrollPosition();
        modal.openedBy = opener;
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        this.lockPageScroll();
        modal.setAttribute('open', '');
        window.pauseAllMedia();
        panel.getBoundingClientRect();
        this.drawerFrameOne = requestAnimationFrame(() => {
          this.drawerFrameTwo = requestAnimationFrame(() => {
            if (!modal.hasAttribute('open') || !this.mobileQuery.matches) return;
            modal.classList.add('is-drawer-visible');
            this.waitForDrawerTransition(
              panel,
              () => {
                if (modal.hasAttribute('open')) trapFocus(modal, modal.querySelector('[role="dialog"]'));
              },
              900
            );
          });
        });
      }

      hideMobileDrawer() {
        const modal = this.controlledModal;
        if (!modal || !modal.hasAttribute('open') || modal.classList.contains('is-drawer-closing')) return;
        const panel = modal.querySelector('.product-popup-modal__content');
        if (!panel) {
          this.finishMobileDrawerClose();
          return;
        }
        this.clearDrawerMotion();
        modal.classList.add('is-drawer-closing');
        this.waitForDrawerTransition(panel, () => this.finishMobileDrawerClose(), 700);
      }

      finishMobileDrawerClose() {
        const modal = this.controlledModal;
        if (!modal) return;
        this.clearDrawerMotion();
        modal.classList.remove('is-drawer-visible', 'is-drawer-closing');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        modal.removeAttribute('open');
        removeTrapFocus(modal.openedBy);
        this.unlockPageScroll();
        window.pauseAllMedia();
        this.runPendingAddToCart();
      }
      waitForDrawerTransition(panel, callback, timeout) {
        this.drawerPanel = panel;
        this.drawerTransitionHandler = (event) => {
          if (event.target !== panel || event.propertyName !== 'transform') return;
          this.clearDrawerMotion();
          callback();
        };
        panel.addEventListener('transitionend', this.drawerTransitionHandler);
        this.drawerTimer = window.setTimeout(() => {
          this.clearDrawerMotion();
          callback();
        }, timeout);
      }

      clearDrawerMotion() {
        cancelAnimationFrame(this.drawerFrameOne);
        cancelAnimationFrame(this.drawerFrameTwo);
        this.drawerFrameOne = null;
        this.drawerFrameTwo = null;
        if (this.drawerTimer) window.clearTimeout(this.drawerTimer);
        this.drawerTimer = null;
        if (this.drawerPanel && this.drawerTransitionHandler)
          this.drawerPanel.removeEventListener('transitionend', this.drawerTransitionHandler);
        this.drawerPanel = null;
        this.drawerTransitionHandler = null;
      }

      resetScrollPosition() {
        const scrollContainer = this.controlledModal?.querySelector('.yg-kit-comparison__scroll');
        if (!scrollContainer) return;
        scrollContainer.scrollTop = 0;
        scrollContainer.scrollLeft = 0;
        this.updateTableHeadVisibility();
      }

      updateTableHeadVisibility() {
        if (!this.scrollContainer || !this.cardsContainer || !this.tableHead) return;
        const cardsHaveScrolledAway =
          this.scrollContainer.scrollTop > 0 &&
          this.cardsContainer.getBoundingClientRect().bottom <= this.scrollContainer.getBoundingClientRect().top + 1;
        this.tableHead.classList.toggle('is-visible', cardsHaveScrolledAway);
        this.tableHead.setAttribute('aria-hidden', String(!cardsHaveScrolledAway));
        this.tableHead.toggleAttribute('inert', !cardsHaveScrolledAway);
      }

      closeAndAddToCart() {
        this.pendingAddToCart = true;
        if (this.modal?.hasAttribute('open')) this.modal.hide();
        else this.runPendingAddToCart();
      }

      runPendingAddToCart() {
        if (!this.pendingAddToCart) return;
        this.pendingAddToCart = false;
        window.requestAnimationFrame(() => {
          const form = this.picker?.form;
          const submitButton = form?.querySelector('[type="submit"][name="add"]');
          if (!form || !submitButton || submitButton.disabled) return;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitButton);
          else submitButton.click();
        });
      }

      lockPageScroll() {
        if (this.pageScrollLocked) return;
        this.pageScrollLocked = true;
        document.documentElement.classList.add('yg-kit-comparison-scroll-lock');
      }

      unlockPageScroll() {
        if (!this.pageScrollLocked) return;
        this.pageScrollLocked = false;
        document.documentElement.classList.remove('yg-kit-comparison-scroll-lock');
      }

      escape(value) {
        const element = document.createElement('div');
        element.textContent = String(value ?? '');
        return element.innerHTML;
      }

      caretIcon() {
        return `
          <svg class="yg-kit-comparison__caret" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
              d="M5.5 7.75L10 12.25L14.5 7.75"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        `;
      }

      checkIcon() {
        return `
          <svg viewBox="0 0 18 18" fill="none" aria-hidden="true">
            <path
              d="M3.75 9.25L7.25 12.75L14.5 5.5"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        `;
      }
      dropdown(scope, slot, variant, dark = false) {
        const key = `${scope}:${slot}`;
        const motionClass =
          this.dropdownMotion?.opening === key
            ? ' is-caret-opening'
            : this.dropdownMotion?.closing === key
            ? ' is-caret-closing'
            : '';
        const usedIds = new Set(this.activeVariants.map((item) => item.id));
        const options =
          this.openDropdown === key
            ? `<div class="yg-kit-comparison__menu" role="listbox">${this.variants
                .map((item) => {
                  const selected = item.id === variant.id;
                  const disabled = !selected && usedIds.has(item.id);
                  return `
                <button type="button" class="yg-kit-comparison__menu-option${
                  selected ? ' is-selected' : ''
                }" role="option" aria-selected="${selected}" data-kit-dropdown-option data-slot="${slot}" data-variant-id="${this.escape(
                    item.id
                  )}" ${disabled ? 'disabled' : ''}>
                  <span>${this.escape(item.title)}</span>
                  ${selected ? this.checkIcon() : ''}
                </button>`;
                })
                .join('')}</div>`
            : '';
        const content = dark
          ? `<span class="yg-kit-comparison__head-copy"><span class="yg-kit-comparison__head-title">${this.escape(
              variant.title
            )}</span><span class="yg-kit-comparison__head-price">${this.escape(variant.price)}${
              variant.comparePrice
                ? `<span class="yg-kit-comparison__compare-price">${this.escape(variant.comparePrice)}</span>`
                : ''
            }</span></span>`
          : `<span class="yg-kit-comparison__trigger-title">${this.escape(variant.title)}</span>`;

        return `
          <div class="yg-kit-comparison__select">
            <button type="button" class="${
              dark ? 'yg-kit-comparison__head-trigger' : 'yg-kit-comparison__select-trigger'
            }${motionClass}" aria-label="${this.escape(
          this.dataset.selectLabel
        )}" aria-haspopup="listbox" aria-expanded="${
          this.openDropdown === key
        }" data-kit-dropdown-trigger data-scope="${scope}" data-slot="${slot}">
              ${content}${this.caretIcon()}
            </button>
            ${options}
          </div>`;
      }

      chooseButton(variant) {
        return `
          <button
            type="button"
            class="yg-kit-comparison__choose"
            data-kit-choose
            data-variant-id="${this.escape(variant.id)}"
          >
            ${this.escape(this.dataset.chooseLabel)}
          </button>`;
      }

      renderCards(variants) {
        return variants
          .map(
            (variant, slot) => `
          <article class="yg-kit-comparison__card${variant.id === this.activeVariantId ? ' is-current' : ''}">
            ${this.dropdown('card', slot, variant)}
            <div class="yg-kit-comparison__card-content">
              <div class="yg-kit-comparison__card-summary">
                <div class="yg-kit-comparison__card-media">
                  ${
                    variant.image
                      ? variant.image
                      : '<span class="yg-kit-comparison__placeholder" aria-hidden="true"></span>'
                  }
                </div>
                <div class="yg-kit-comparison__card-copy">
                  <p class="yg-kit-comparison__description">${this.escape(variant.description)}</p>
                  <p class="yg-kit-comparison__price">${this.escape(variant.price)}${
              variant.comparePrice
                ? `<span class="yg-kit-comparison__compare-price">${this.escape(variant.comparePrice)}</span>`
                : ''
            }</p>
                </div>
              </div>
              ${this.chooseButton(variant)}
            </div>
          </article>`
          )
          .join('');
      }

      renderHead(variants) {
        return variants
          .map(
            (variant, slot) =>
              `<div class="yg-kit-comparison__head-cell">${this.dropdown('head', slot, variant, true)}</div>`
          )
          .join('');
      }
      renderRows(variants) {
        const rowCount = Math.max(0, ...variants.map((variant) => variant.items.length));
        return Array.from({ length: rowCount }, (_, index) => {
          const fallback = variants.map((variant) => variant.items[index]).find(Boolean) || {};
          const cells = variants
            .map((variant, slot) => {
              const item = variant.items[index];
              const displayItem = item || fallback;
              const muted = !item || item.number <= 0;
              const image = displayItem.image
                ? displayItem.image
                : '<span class="yg-kit-comparison__placeholder" aria-hidden="true"></span>';
              return `
              <div class="yg-kit-comparison__table-cell${muted ? ' is-muted' : ''}" data-slot="${slot}">
                <div class="yg-kit-comparison__item-media">${image}</div>
                <p class="yg-kit-comparison__item-name">${this.escape(displayItem.name || '')}</p>
                <p class="yg-kit-comparison__item-count">x${item ? item.number : 0}</p>
              </div>`;
            })
            .join('');
          return `<div class="yg-kit-comparison__table-row">${cells}</div>`;
        }).join('');
      }

      renderDropdowns() {
        const variants = this.activeVariants;
        ['card', 'head'].forEach((scope) => {
          variants.forEach((variant, slot) => {
            const trigger = this.querySelector(
              `[data-kit-dropdown-trigger][data-scope="${scope}"][data-slot="${slot}"]`
            );
            const select = trigger?.closest('.yg-kit-comparison__select');
            if (select) select.outerHTML = this.dropdown(scope, slot, variant, scope === 'head');
          });
        });
      }

      render() {
        const variants = this.activeVariants;
        this.style.setProperty('--yg-kit-comparison-columns', variants.length || 1);
        this.querySelector('[data-kit-comparison-cards]').innerHTML = this.renderCards(variants);
        this.querySelector('[data-kit-comparison-head]').innerHTML = this.renderHead(variants);
        this.querySelector('[data-kit-comparison-body]').innerHTML = this.renderRows(variants);
        this.querySelector('[data-kit-comparison-actions]').innerHTML = variants
          .map(
            (variant, slot) =>
              `<div class="yg-kit-comparison__action-cell" data-slot="${slot}">${this.chooseButton(variant)}</div>`
          )
          .join('');
        this.updateTableHeadVisibility();
      }
    }

    customElements.define('yg-variant-kit-comparison', YGVariantKitComparison);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-variant-suit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yg-variant-suit')) {
    customElements.define(
      'yg-variant-suit',
      class YGVariantSuit extends HTMLElement {
        connectedCallback() {
          if (this.ready) return;

          this.ready = true;
          this.picker = this.closest('yg-variant-kit-picker');
          this.cards = this.picker?.querySelector('.yg-variant-kit-picker__cards');
          this.gallery = document.getElementById(`MediaGallery-${this.dataset.sectionId}`);
          this.dock = this.gallery?.querySelector('.mondo-gallery__dock');
          this.desktop = this.querySelector('[data-suit-desktop]');
          this.panels = Array.from(this.desktop?.querySelectorAll('[data-suit-panel]') || []);
          this.dialog = this.querySelector('[data-suit-dialog]');
          this.dropdown = this.querySelector('[data-suit-dropdown]');
          this.select = this.querySelector('[data-suit-select]');
          this.selected = this.querySelector('[data-suit-selected]');
          this.menu = this.querySelector('[data-suit-menu]');
          this.options = Array.from(this.querySelectorAll('[data-suit-option]'));
          this.scrollArea = this.querySelector('[data-suit-scroll]');
          this.gradient = this.querySelector('[data-suit-gradient]');
          this.copies = Array.from(this.querySelectorAll('[data-suit-copy]'));
          this.mobileGrids = Array.from(this.querySelectorAll('[data-suit-mobile-grid]'));
          this.variantIds = new Set(this.panels.map((panel) => panel.dataset.variantId));
          this.activeId = String(this.dataset.activeVariantId || '');
          this.media = matchMedia('(min-width:1000px)');
          this.frame = null;
          this.displayMode = 'auto';
          this.mediaModeExitedAutoZone = false;

          this.onVariant = (event) => {
            if (String(event.detail?.sectionId) === String(this.dataset.sectionId)) {
              this.updateVariant(String(event.detail.variantId));
            }
          };

          this.onSelect = () => this.setDropdownOpen(this.menu?.hidden);
          this.onOptionClick = (event) => {
            const option = event.target.closest('[data-suit-option]');
            if (!option) return;

            const id = String(option.dataset.variantId);
            this.picker?.selectVariantById(id);
            this.updateVariant(id);
            this.setDropdownOpen(false);
            this.select?.focus();
          };
          this.onDropdownKeydown = (event) => {
            if (event.key === 'Escape' && !this.menu?.hidden) {
              event.preventDefault();
              this.setDropdownOpen(false);
              this.select?.focus();
              return;
            }

            if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;

            event.preventDefault();
            if (this.menu?.hidden) this.setDropdownOpen(true);

            const focusedOption = event.target.closest('[data-suit-option]');
            const selectedIndex = this.options.findIndex((option) => option.classList.contains('is-selected'));
            let index = focusedOption ? this.options.indexOf(focusedOption) : selectedIndex;

            if (event.key === 'Home') index = 0;
            if (event.key === 'End') index = this.options.length - 1;
            if (event.key === 'ArrowDown') index = (index + 1 + this.options.length) % this.options.length;
            if (event.key === 'ArrowUp') index = (index - 1 + this.options.length) % this.options.length;
            this.options[index]?.focus();
          };
          this.onDocumentPointerDown = (event) => {
            if (!this.menu?.hidden && !event.composedPath().includes(this.dropdown)) {
              this.setDropdownOpen(false);
            }
          };
          this.onDialogClick = (event) => {
            if (event.target === this.dialog) this.dialog.close();
          };

          this.onCardsClick = (event) => {
            const card = event.target.closest('[data-variant-card]');
            if (!this.media.matches || !card || !this.cards?.contains(card)) return;

            this.displayMode = 'suit';
            this.mediaModeExitedAutoZone = false;
            this.schedule();
          };

          this.onDockClick = (event) => {
            const thumbnail = event.target.closest('.thumbnail-list__item.slider__slide');
            if (!this.media.matches || !thumbnail || !this.dock?.contains(thumbnail)) return;

            const rect = this.picker?.getBoundingClientRect();
            this.displayMode = 'media';
            this.mediaModeExitedAutoZone = rect ? !this.isInAutoZone(rect) : true;
            this.setDesktopVisible(false);
            this.schedule();
          };

          this.onClose = () => {
            this.setDropdownOpen(false);
            this.unlock();
            if (this.opener?.isConnected) this.opener.focus();
          };

          this.onBreakpoint = () => {
            this.displayMode = 'auto';
            this.mediaModeExitedAutoZone = false;
            this.setDropdownOpen(false);
            if (this.media.matches && this.dialog?.open) this.dialog.close();
            this.updateHeight();
            this.schedule();
          };

          this.schedule = () => {
            if (this.frame !== null) return;

            this.frame = requestAnimationFrame(() => {
              this.frame = null;
              this.evaluate();
            });
          };

          this.updateGradient = () => {
            if (!this.scrollArea || !this.gradient) return;

            const remaining =
              this.scrollArea.scrollHeight - this.scrollArea.scrollTop - this.scrollArea.clientHeight;
            this.gradient.classList.toggle('is-visible', remaining > 2);
          };

          if (this.gallery && this.desktop) this.gallery.appendChild(this.desktop);
          this.picker?.addEventListener('yg:variant-change', this.onVariant);
          this.cards?.addEventListener('click', this.onCardsClick);
          this.dock?.addEventListener('click', this.onDockClick);
          this.select?.addEventListener('click', this.onSelect);
          this.dropdown?.addEventListener('keydown', this.onDropdownKeydown);
          this.menu?.addEventListener('click', this.onOptionClick);
          document.addEventListener('pointerdown', this.onDocumentPointerDown);
          this.querySelector('[data-suit-close]')?.addEventListener('click', () => this.dialog?.close());
          this.dialog?.addEventListener('click', this.onDialogClick);
          this.dialog?.addEventListener('close', this.onClose);
          this.scrollArea?.addEventListener('scroll', this.updateGradient, { passive: true });
          this.media.addEventListener('change', this.onBreakpoint);
          addEventListener('scroll', this.schedule, { passive: true });
          addEventListener('resize', this.schedule, { passive: true });

          this.galleryObserver = new ResizeObserver(() => {
            this.updateHeight();
            this.schedule();
          });

          if (this.gallery) this.galleryObserver.observe(this.gallery);
          if (this.dock) this.galleryObserver.observe(this.dock);

          this.scrollObserver = new ResizeObserver(this.updateGradient);
          if (this.scrollArea) this.scrollObserver.observe(this.scrollArea);

          this.updateVariant(this.activeId);
          this.updateHeight();
          requestAnimationFrame(() => {
            this.evaluate();
            this.updateGradient();
          });
        }
        disconnectedCallback() {
          this.picker?.removeEventListener('yg:variant-change', this.onVariant);
          this.cards?.removeEventListener('click', this.onCardsClick);
          this.dock?.removeEventListener('click', this.onDockClick);
          this.select?.removeEventListener('click', this.onSelect);
          this.dropdown?.removeEventListener('keydown', this.onDropdownKeydown);
          this.menu?.removeEventListener('click', this.onOptionClick);
          document.removeEventListener('pointerdown', this.onDocumentPointerDown);
          this.dialog?.removeEventListener('click', this.onDialogClick);
          this.dialog?.removeEventListener('close', this.onClose);
          this.scrollArea?.removeEventListener('scroll', this.updateGradient);
          this.media?.removeEventListener('change', this.onBreakpoint);
          removeEventListener('scroll', this.schedule);
          removeEventListener('resize', this.schedule);
          this.galleryObserver?.disconnect();
          this.scrollObserver?.disconnect();

          if (this.frame !== null) cancelAnimationFrame(this.frame);

          this.hideDesktop();
          this.unlock();
          this.desktop?.remove();
          this.ready = false;
        }

        openDrawer(id, opener) {
          id = String(id);
          if (this.media.matches || !this.variantIds.has(id) || !this.dialog) return;

          this.opener = opener;
          this.updateVariant(id);
          if (!this.dialog.open) this.dialog.showModal();
          this.lock();
          requestAnimationFrame(this.updateGradient);
        }
        setDropdownOpen(open) {
          if (!this.select || !this.menu) return;

          this.select.setAttribute('aria-expanded', String(open));
          this.menu.hidden = !open;
        }

        updateDropdown() {
          const activeOption = this.options.find((option) => option.dataset.variantId === this.activeId);
          if (!activeOption) return;

          this.options.forEach((option) => {
            const selected = option === activeOption;
            option.classList.toggle('is-selected', selected);
            option.setAttribute('aria-selected', String(selected));
          });
          this.selected.textContent = activeOption.querySelector('span')?.textContent.trim() || '';
        }

        updateVariant(id) {
          this.activeId = String(id || '');
          this.toggle(this.panels);
          this.toggle(this.copies);
          this.toggle(this.mobileGrids);

          if (this.variantIds.has(this.activeId)) {
            this.updateDropdown();
          } else if (this.dialog?.open) {
            this.dialog.close();
          }

          if (this.scrollArea) this.scrollArea.scrollTop = 0;
          this.schedule();
          requestAnimationFrame(this.updateGradient);
        }

        toggle(elements) {
          elements.forEach((element) => {
            const active = element.dataset.variantId === this.activeId;
            element.hidden = !active;
            element.setAttribute('aria-hidden', String(!active));
          });
        }

        evaluate() {
          if (!this.media.matches || !this.picker || !this.gallery || !this.variantIds.has(this.activeId)) {
            this.hideDesktop();
            return;
          }

          const rect = this.picker.getBoundingClientRect();
          const inAutoZone = this.isInAutoZone(rect);
          let visible = false;

          if (this.displayMode === 'suit') {
            if (rect.bottom <= 0) {
              this.displayMode = 'auto';
            } else {
              visible = true;
            }
          } else if (this.displayMode === 'media') {
            if (!inAutoZone) this.mediaModeExitedAutoZone = true;
            if (inAutoZone && this.mediaModeExitedAutoZone) {
              this.displayMode = 'auto';
              this.mediaModeExitedAutoZone = false;
              visible = true;
            }
          } else {
            visible = inAutoZone;
          }

          this.setDesktopVisible(visible);
        }
        isInAutoZone(rect) {
          return rect.top <= 0 && rect.bottom > 0;
        }
        setDesktopVisible(visible) {
          this.desktop?.classList.toggle('is-active', visible);
          this.gallery?.classList.toggle('is-yg-variant-suit-visible', visible);
        }
        hideDesktop() {
          this.setDesktopVisible(false);
        }

        updateHeight() {
          if (!this.gallery || !this.desktop) return;

          const height = Math.max(
            0,
            this.gallery.getBoundingClientRect().height -
              (this.dock?.getBoundingClientRect().height || 0) -
              48,
          );
          this.desktop.style.setProperty('--suit-height', `${height}px`);
        }

        lock() {
          document.documentElement.classList.add('yg-variant-suit-dialog-open');
        }

        unlock() {
          document.documentElement.classList.remove('yg-variant-suit-dialog-open');
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
    constructor() {
      super();
    }

    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'title-list': Array.from(this.children),
        'content-list': Array.from(
          document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || []
        ),
      };

      return this._sectionsEl;
    }

    connectedCallback() {
      this.initTabs();
      this.addEventListener('click', (e) => {
        let item = e.target.closest('.tab-title');
        if (item) {
          let i = this.sectionsEl['title-list'].indexOf(item);
          this.itemClick(item, i);
        }
      });

      if (typeof ResizeObserver !== 'undefined') {
        this.tabResizeObserver = new ResizeObserver(() => this.scheduleStyleUpdate());
        this.sectionsEl['title-list'].forEach((item) => this.tabResizeObserver.observe(item));
      }
    }

    disconnectedCallback() {
      this.tabResizeObserver?.disconnect();

      if (this.styleUpdateFrame) {
        cancelAnimationFrame(this.styleUpdateFrame);
        this.styleUpdateFrame = null;
      }
    }

    initTabs() {
      this.sectionsEl['title-list']?.forEach((el, i) => {
        if (!el.classList.contains('tab-title')) {
          el.classList.add('tab-title');
        }

        if (i == 0) {
          el.classList.add('is-active');
        }
      });
      this.updateStyle(this.sectionsEl['title-list'][0]);

      this.sectionsEl['content-list'].forEach((el, i) => {
        if (!el.classList.contains('tab-content')) {
          el.classList.add('tab-content');
        }

        if (i == 0) el.classList.add('is-active');
      });
    }

    itemClick(el, i) {
      // 如果已经激活则直接返回
      if (el.classList.contains('is-active')) return;

      this.scrollItemIntoView(el);
      this.toggleClass(el, i);
    }

    scrollItemIntoView(el, options = {}) {
      const scrollContainer = this.closest('.yg-scroll-container');
      if (!scrollContainer || !el) return;

      const { behavior = 'smooth' } = options;
      const containerRect = scrollContainer.getBoundingClientRect();
      const itemRect = el.getBoundingClientRect();
      const currentScrollLeft = scrollContainer.scrollLeft;
      const rawScrollLeft =
        currentScrollLeft + (itemRect.left - containerRect.left) - (scrollContainer.clientWidth - itemRect.width) / 2;
      const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
      const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

      if (typeof scrollContainer.scrollTo === 'function') {
        scrollContainer.scrollTo({
          left: nextScrollLeft,
          behavior,
        });
        return;
      }

      scrollContainer.scrollLeft = nextScrollLeft;
    }

    toggleClass(el, i) {
      // 处理标题激活状态
      this.sectionsEl['title-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      el.classList.add('is-active');
      this.updateStyle(el);

      // 处理内容激活状态
      this.sectionsEl['content-list'].forEach((item) => {
        item.classList.remove('is-active');
      });
      if (this.sectionsEl['content-list'][i]) this.sectionsEl['content-list'][i].classList.add('is-active');
    }

    updateStyle(el = null) {
      let itemEl = el || this.querySelector('.is-active');

      if (!itemEl) return;
      let left = itemEl.offsetLeft;
      let width = itemEl.offsetWidth;
      this.style.setProperty('--scroll-item-left', `${left}px`);
      this.style.setProperty('--scroll-item-width', `${width}px`);
    }

    scheduleStyleUpdate() {
      if (this.styleUpdateFrame) cancelAnimationFrame(this.styleUpdateFrame);

      this.styleUpdateFrame = requestAnimationFrame(() => {
        this.styleUpdateFrame = null;
        this.updateStyle();
      });
    }
  }
  if (!window.customElements.get('yg-tabs-title')) {
    window.customElements.define('yg-tabs-title', YGTabsTitle);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.typeMobile = this.getAttribute('data-type-mobile');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
        this.watchAutoplayVisibility();
      }

      // 跨 700px 断点 resize 时，按需重建当前断点视频，避免换源后空白
      this.watchBreakpointChange();

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    disconnectedCallback() {
      this.breakpointQuery?.removeEventListener?.('change', this.breakpointChangeHandler);
      this.autoplayVisibilityObserver?.disconnect();
    }

    get isMobileBreakpoint() {
      return !!(window.matchMedia && window.matchMedia('(max-width: 999px)').matches);
    }

    get currentType() {
      return this.isMobileBreakpoint ? this.typeMobile : this.type;
    }

    // 克隆 template 内容，并剔除非当前断点的视频/iframe，仅保留当前断点元素
    cloneMediaForCurrentBreakpoint() {
      const fragment = this.template?.content.cloneNode(true);
      if (!fragment) return fragment;

      const isMobile = this.isMobileBreakpoint;
      const offClass = isMobile ? 'hide-mobile' : 'hide-pc';
      const activeClass = isMobile ? 'hide-pc' : 'hide-mobile';
      fragment.querySelectorAll('.' + offClass).forEach((el) => el.remove());
      fragment.querySelectorAll('.' + activeClass).forEach((el) => el.classList.remove(activeClass));

      return fragment;
    }

    // resize 跨断点时重建：移除旧容器并按当前断点重新实例化，必要时恢复播放
    watchBreakpointChange() {
      if (!window.matchMedia) return;

      this.breakpointQuery = window.matchMedia('(max-width: 999px)');
      this.breakpointChangeHandler = () => {
        // 弹窗模式不在此处实例化；尚未实例化则无需处理
        if (this.popup == 'true' || !this.videoContainer) return;

        const wasPlaying = this.__ygIsPlaying === true;
        this.videoContainer.remove();
        if (wasPlaying) {
          this.playVideo();
        }
      };

      if (this.breakpointQuery.addEventListener) {
        this.breakpointQuery.addEventListener('change', this.breakpointChangeHandler);
      } else if (this.breakpointQuery.addListener) {
        // 旧浏览器兜底
        this.breakpointQuery.addListener(this.breakpointChangeHandler);
      }
    }

    watchAutoplayVisibility() {
      if (!window.IntersectionObserver || this.autoplayVisibilityObserver) return;

      this.autoplayVisibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.resumeAutoplayVideo();
        });
      }, {
        rootMargin: '0px',
        threshold: 0.2,
      });

      this.autoplayVisibilityObserver.observe(this);
    }

    resumeAutoplayVideo() {
      if (this.popup == 'true' || this.autoplay != 'true') return;

      if (!this.videoContainer) {
        this.playVideo();
        return;
      }

      if (this.currentType != 'video') return;

      const videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
      videos.forEach((video) => {
        if (this.isResponsiveVideoHidden(video)) return;

        if (this.loop == 'false' && video instanceof HTMLVideoElement) {
          video.loop = false;
          video.removeAttribute('loop');
        }

        this.revealVideoWhenPlaying(video);
        const playRequest = video.play();
        if (playRequest?.catch) {
          playRequest.catch(() => {});
        }
      });
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      if (!this.videoContainer) {
        const fragment = this.cloneMediaForCurrentBreakpoint();
        if (fragment) this.appendChild(fragment);
      }

      if (this.currentType == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.add('close');
        this.switcherVideoButtonState("play")
        this.__ygIsPlaying = true;
        videos.forEach(video => {
          if (this.loop == 'false' && video instanceof HTMLVideoElement) {
            video.loop = false;
            video.removeAttribute('loop');
          }

          this.revealVideoWhenPlaying(video);
          const playRequest = video.play();
          if (playRequest?.catch) {
            playRequest.catch((error) => {
              if (error?.name === 'AbortError') return;
              this.pauseVideo();
            });
          }
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      } else {
        this.image?.classList.add('close');
        this.switcherVideoButtonState("play")
        this.__ygIsPlaying = true;
      }


    }

    revealVideoWhenPlaying(video) {
      if (!video || this.isResponsiveVideoHidden(video)) return;

      const reveal = () => {
        this.videoContainer?.classList.remove('close');
        this.image?.classList.add('close');
      };

      if (typeof video.requestVideoFrameCallback === 'function') {
        video.requestVideoFrameCallback(reveal);
        return;
      }

      if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
        reveal();
        return;
      }

      video.addEventListener('playing', reveal, { once: true });
    }

    isResponsiveVideoHidden(video) {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 999px)').matches;

      if (isMobile && video.classList.contains('hide-mobile')) return true;
      if (!isMobile && video.classList.contains('hide-pc')) return true;

      return false;
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      this.__ygIsPlaying = false;

      if (this.currentType == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 999px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
